// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/zdq7lvi.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
* {
  margin: 0;
  padding: 0;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

html {
  height: -webkit-fill-available;
}

body {
  background: #f8f8f2;
  min-height: 100%;
  /* mobile viewport bug fix */
  min-height: -webkit-fill-available;
}

img {
  display: inherit;
}

h2 {
  font-weight: unset;
}

.home, .page {
  transition: 0.25s transform;
}
.home .section__copy, .home .top, .page .section__copy, .page .top {
  text-align: left;
  width: 95%;
}
.home .section__copy .headline, .home .top .headline, .page .section__copy .headline, .page .top .headline {
  font-weight: unset;
  display: inline;
  font-size: 6vw;
  line-height: 6.5vw;
}
.home .section__copy .headline:nth-child(2), .home .top .headline:nth-child(2), .page .section__copy .headline:nth-child(2), .page .top .headline:nth-child(2) {
  color: #000;
}
.home .section__copy .headline:nth-child(2):before, .home .top .headline:nth-child(2):before, .page .section__copy .headline:nth-child(2):before, .page .top .headline:nth-child(2):before {
  content: "\\a";
  white-space: pre;
}
@media (min-width: 970px) {
  .home .section__copy p, .home .top p, .page .section__copy p, .page .top p {
    padding-left: 40px;
    width: 40%;
    display: inline-block;
    vertical-align: top;
  }
}

.image-full-width img {
  width: 100% !important;
}

.module-2-column {
  margin: 20px 0;
}
.module-2-column img, .module-2-column .looping-video, .module-2-column .module-2-column__image {
  width: 100%;
  display: inherit;
  margin-bottom: 20px;
  object-fit: cover;
}
.module-2-column img:last-child, .module-2-column .looping-video:last-child, .module-2-column .module-2-column__image:last-child {
  margin-bottom: 0;
}
@media (min-width: 970px) {
  .module-2-column img, .module-2-column .looping-video, .module-2-column .module-2-column__image {
    width: calc(50% - 10px) !important;
    margin: 0 20px 0 0 !important;
    display: inline-block;
    vertical-align: top;
  }
  .module-2-column img:last-child, .module-2-column .looping-video:last-child, .module-2-column .module-2-column__image:last-child {
    margin-right: 0 !important;
  }
}
.module-2-column .looping-video {
  width: 100%;
  margin-top: 20px;
}
.module-2-column .looping-video:last-child {
  margin-right: 0 !important;
}
.module-2-column .module-2-column__image img {
  width: 100% !important;
}
.module-2-column .module-2-column__image .caption {
  display: block !important;
}

body {
  font-family: degular, sans-serif;
  font-weight: 400;
  font-style: normal;
}

p, .headline, .client-name {
  margin: auto;
}

.button {
  cursor: pointer;
}

.headline {
  font-family: degular, sans-serif;
  font-style: normal;
  position: relative;
  font-size: 4vh;
  line-height: 4.5vh;
  text-align: left;
  margin-bottom: 1.5vh;
}
.headline b {
  color: inherit;
  font-weight: 700;
  font-style: normal;
  background-color: inherit;
}
@media (min-width: 970px) {
  .headline {
    font-size: 6vw;
    line-height: 6.5vw;
    display: inline-block;
    vertical-align: middle;
  }
}

.caption {
  font-size: 16px;
  margin: 10px !important;
  width: unset !important;
}
@media (min-width: 970px) {
  .caption {
    font-size: 21px;
    padding: 60px 7.5%;
  }
}

.looping-video, .standard-video {
  margin: 20px 0;
}

b {
  display: inline-block;
}

p {
  position: relative;
  z-index: 1;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  display: block;
  margin-top: 20px;
}
p.size-2 {
  font-size: 18px !important;
}
p:first-child {
  margin-top: 0;
}
p:empty {
  display: none !important;
}
@media (min-width: 970px) {
  p {
    font-size: 24px;
    line-height: 32px;
    vertical-align: middle;
  }
}

.background:empty {
  display: none;
}

.hide {
  display: none;
}

.expand-icon {
  cursor: pointer;
  filter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);
  display: inline-block;
  vertical-align: middle;
  transform-origin: left;
  display: none;
  width: 6vh;
  margin-top: 15px;
}
.expand-icon:hover {
  animation: bubble 1s;
  animation-timing-function: ease-out;
}
@keyframes bubble {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
@media (min-width: 970px) {
  .expand-icon {
    position: absolute;
    bottom: 8px;
    width: 5vw;
    height: auto;
    margin-left: 2.5vw;
  }
}

a {
  position: relative;
  text-decoration-color: #55FF9E;
  text-underline-position: under;
  padding: 5px;
  text-indent: -5px;
  color: #000;
}
a.size-2 {
  font-size: 18px !important;
}
a:hover {
  background-color: #55FF9E;
}
a:hover:after {
  display: none;
}
a.image-link:hover {
  background-color: unset;
}

.gradient-theme, .content__item.gradient-theme, .embed__item.gradient-theme {
  color: #FFF;
  background: linear-gradient(270deg, rgb(251, 98, 48) 0%, rgb(252, 91, 65) 40%, rgb(252, 120, 79) 60%, rgb(252, 169, 54) 100%);
}
.gradient-theme .headline, .content__item.gradient-theme .headline, .embed__item.gradient-theme .headline {
  color: #FFF;
}
.gradient-theme .headline:nth-child(2), .content__item.gradient-theme .headline:nth-child(2), .embed__item.gradient-theme .headline:nth-child(2) {
  color: #000;
}
.gradient-theme a, .content__item.gradient-theme a, .embed__item.gradient-theme a {
  color: #55FF9E;
}
.gradient-theme .expand-icon, .content__item.gradient-theme .expand-icon, .embed__item.gradient-theme .expand-icon {
  color: #FFF;
}

.dark-theme, .content__item.dark-theme, .embed__item.dark-theme {
  color: #FFF;
  background-color: #000;
}
.dark-theme .headline, .content__item.dark-theme .headline, .embed__item.dark-theme .headline {
  color: #FFF;
}
.dark-theme .headline:nth-child(2), .content__item.dark-theme .headline:nth-child(2), .embed__item.dark-theme .headline:nth-child(2) {
  color: #FFF;
}
.dark-theme a, .content__item.dark-theme a, .embed__item.dark-theme a {
  color: #55FF9E;
}
.dark-theme .expand-icon, .content__item.dark-theme .expand-icon, .embed__item.dark-theme .expand-icon {
  color: #FFF;
}

.light-theme, .content__item.light-theme, .embed__item.light-theme {
  color: #000;
  background-color: #F8F8F3;
}
.light-theme a, .content__item.light-theme a, .embed__item.light-theme a {
  color: #000;
}
.light-theme .headline, .content__item.light-theme .headline, .embed__item.light-theme .headline {
  color: #FF3B00;
}
.light-theme .expand-icon, .content__item.light-theme .expand-icon, .embed__item.light-theme .expand-icon {
  color: #000;
}

@keyframes bounce {
  0% {
    margin-top: 0;
  }
  30% {
    margin-top: -40px;
  }
  50% {
    margin-top: -15px;
  }
  100% {
    margin: 0;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOff {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes growRight {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
.app {
  position: absolute;
  width: 100%;
}
.app.home {
  height: 100%;
}
.app:after {
  content: "";
  background: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.2));
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100px;
  z-index: 3;
  pointer-events: none;
}
.app.nav-expanded .home, .app.nav-expanded .page {
  transform: translateX(-300px);
}
@media (min-width: 970px) {
  .app.nav-expanded .home, .app.nav-expanded .page {
    transform: translateX(-500px);
  }
}

.nav {
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 4;
}
.nav.orange .nav__logo {
  filter: unset;
}
.nav.orange .nav__menu .nav__menu__button.close .line {
  background-color: #FFF;
}
.nav.orange .nav__menu .nav__menu__button .line {
  background-color: #FF3B00;
}
.nav a {
  color: unset;
  text-decoration: none;
}
.nav a:hover {
  background: none;
}
.nav__logo {
  position: absolute;
  width: 65px;
  transition: 0.5s all ease-out;
  filter: brightness(0) invert(1);
  -webkit-user-select: none;
          user-select: none;
  top: 15px;
  left: 15px;
}
@media (min-width: 1300px) {
  .nav__logo {
    width: 75px;
  }
}
.nav__logo.hidden {
  transform: translateY(-300px);
}
.nav__logo img {
  width: 100%;
}
.nav__menu {
  font-size: 24px;
}
@media (min-width: 970px) {
  .nav__menu {
    font-size: 30px;
  }
}
.nav__menu__expanded {
  position: fixed;
  transition: 0.25s transform;
  top: 0;
  background: linear-gradient(120deg, rgb(251, 98, 48) 0%, rgb(252, 91, 65) 40%, rgb(252, 120, 79) 60%, rgb(252, 169, 54) 100%);
  padding: 4vh 20px;
  transform: translateX(100vw);
  width: 300px;
  height: 100vh;
}
@media (min-width: 970px) {
  .nav__menu__expanded {
    width: 500px;
  }
}
.nav__menu__expanded.active {
  transform: translateX(calc(100vw - 300px));
}
@media (min-width: 970px) {
  .nav__menu__expanded.active {
    transform: translateX(calc(100vw - 500px));
  }
}
.nav__menu__expanded__list {
  color: #FFF;
  position: relative;
  list-style: none;
  text-align: center;
}
.nav__menu__expanded__list.social {
  transform: none;
  top: unset;
  margin-top: 10vh;
}
.nav__menu__expanded__list.social:before {
  position: absolute;
  left: 10%;
  top: -5vh;
  content: "";
  width: 80%;
  height: 20px;
  border-top: solid 2px #FFF;
}
.nav__menu__expanded__list.global {
  margin-top: 5vh;
}
.nav__menu__expanded__list.global li {
  display: inline-block;
  font-size: 14px;
  margin: 0 10px;
}
.nav__menu__expanded__list.global li.global {
  font-size: 24px;
  display: block;
  width: 50%;
  margin: 20px auto;
}
@media (min-width: 970px) {
  .nav__menu__expanded__list.global li.global {
    font-size: 30px;
    width: 40%;
  }
}
.nav__menu__expanded__list.global li::after {
  height: 1px;
}
@media (min-width: 970px) {
  .nav__menu__expanded__list.global li {
    font-size: 15px;
    margin: 0 20px;
  }
}
.nav__menu__expanded__list li {
  position: relative;
  display: table;
  margin: 3vh auto;
  cursor: pointer;
}
.nav__menu__expanded__list li:first-child {
  margin-top: 0;
}
.nav__menu__expanded__list li:last-child {
  margin-bottom: 0;
}
.nav__menu__expanded__list li:after {
  transition: 0.3s all ease-in-out;
  position: absolute;
  bottom: -8px;
  left: 0;
  height: 2px;
  background-color: #FFF;
  content: "";
  width: 0;
}
.nav__menu__expanded__list li:hover:after {
  width: 100%;
}
.nav__menu__button {
  position: relative;
  width: 30px;
  height: 15px;
  float: right;
  cursor: pointer;
  z-index: 3;
  -webkit-user-select: none;
          user-select: none;
  top: 15px;
  right: 15px;
}
.nav__menu__button:hover .line:first-child {
  transform: translateY(3px);
}
.nav__menu__button:hover .line:last-child {
  transform: translateY(-3px);
}
.nav__menu__button.close .line {
  background-color: #FFF;
}
.nav__menu__button.close .line:first-child {
  top: 50%;
  transform: rotate(45deg);
}
.nav__menu__button.close .line:last-child {
  top: 50%;
  transform: rotate(-45deg);
}
.nav__menu__button .line {
  width: 100%;
  height: 3px;
  background-color: #FFF;
  position: absolute;
  transition: 0.2s ease-out all;
}
.nav__menu__button .line:nth-child(1) {
  top: 0;
  left: 0;
}
.nav__menu__button .line:nth-child(2) {
  bottom: 0;
  left: 0;
}

.footer {
  position: absolute;
  left: 0;
  z-index: 3;
  background-color: #FF3B00;
  padding: 10px;
  color: #FFF;
  width: 100vw;
  height: 70px;
  box-shadow: inset 0px 25px 30px -13px rgba(0, 0, 0, 0.3);
  font-size: 15px;
  opacity: 0;
  transition: 0.5s opacity ease-out;
}
.footer.loaded {
  opacity: 1;
}
@media (min-width: 970px) {
  .footer {
    padding: 20px 40px;
    height: unset;
    height: 90px;
    font-size: 24px;
  }
}
.footer__column {
  width: 50%;
  display: inline-block;
  height: 100%;
  transition: 0.3s all ease-out;
  margin-top: 10px;
}
@media (max-width: 969px) {
  .footer__column {
    margin-top: 0;
  }
}
.footer__column.left, .footer__column.right {
  white-space: nowrap;
}
.footer__column.left a, .footer__column.right a {
  color: #FFF;
  padding: 0;
  text-decoration-color: #FFF;
  text-decoration: none;
}
.footer__column.left a:hover, .footer__column.right a:hover {
  background: unset;
}
.footer__column.left {
  position: relative;
  z-index: 3;
  width: 60%;
}
@media (max-width: 969px) {
  .footer__column.left {
    width: 50%;
  }
}
.footer__column.left .footer__email, .footer__column.left .terms-privacy {
  display: block;
  margin-bottom: 20px;
}
@media (min-width: 970px) {
  .footer__column.left .footer__email, .footer__column.left .terms-privacy {
    display: inline-block;
    margin: 0;
  }
  .footer__column.left .footer__email:last-child, .footer__column.left .terms-privacy:last-child {
    margin-bottom: unset;
  }
}
.footer__column.left .footer__email {
  margin-bottom: 0;
  white-space: nowrap;
}
.footer__column.left .terms-privacy {
  display: block;
  margin-bottom: 0;
}
@media (max-width: 969px) {
  .footer__column.left .terms-privacy {
    line-height: 15px;
  }
}
@media (min-width: 970px) {
  .footer__column.left .terms-privacy {
    margin-left: 2vw;
    display: inline-block;
  }
}
.footer__column.left .terms-privacy a {
  color: #dbdbdb;
  opacity: 0.5;
}
.footer__column.left .terms-privacy a:hover {
  opacity: 1;
  text-decoration: underline;
}
.footer__column.right {
  text-align: right;
  width: 40%;
  left: 0;
  top: 0;
  height: 100%;
  display: inline-block;
}
@media (min-width: 970px) {
  .footer__column.right {
    position: relative;
  }
}
@media (max-width: 969px) {
  .footer__column.right {
    line-height: 15px;
    width: 50%;
    vertical-align: top;
  }
  .footer__column.right .social__link {
    margin-right: 10px;
  }
}
.footer__column.right .social__link {
  cursor: pointer;
  display: inline-block;
}
@media (min-width: 970px) {
  .footer__column.right .social__link {
    margin-left: 2.4vw;
  }
}
.footer__column.right .social__link:hover {
  text-decoration: underline;
}

:root {
  --textIndent: 0;
}

@keyframes marquee {
  0% {
    text-indent: 0;
  }
  100% {
    text-indent: var(--textIndent);
  }
}
@keyframes marqueeDesktop {
  0% {
    text-indent: 0;
  }
  100% {
    text-indent: var(--textIndent);
  }
}
.banner {
  background-color: #55FF9E;
  color: #000;
  white-space: nowrap;
  text-transform: uppercase;
  padding: 10px 0;
  overflow-x: hidden;
  animation: 8s marquee linear infinite;
  font-size: 32px;
  line-height: 50px;
}
@media (min-width: 1800px) {
  .banner {
    height: 100px;
    animation: 8s marqueeDesktop linear infinite;
    font-size: 80px;
    line-height: 70px;
  }
}
.banner span {
  margin-left: 10px;
}

.content__item.active:before {
  opacity: 1;
}
.content__item__section.description {
  height: 100vh;
}
.content__item__section.description .section__copy {
  top: 50%;
  transform: translateY(-50%);
}
.content__item__section.description .section__copy.fade p {
  mask-image: -webkit-gradient(linear, left 20%, left 70%, from(rgb(0, 0, 0)), to(rgba(0, 0, 0, 0)));
  margin-bottom: 0;
}
@media (min-width: 970px) {
  .content__item__section.description .section__copy.fade p {
    mask-image: none;
    margin-top: 40px;
  }
}
.content__item__section.expanded .headline, .content__item__section.expanded p {
  color: inherit !important;
}
.content__item__section.expanded p {
  width: unset;
  display: block;
}
.content__item__section.expanded .embed__item:last-child {
  padding-bottom: 70px;
}
.content__item__section .section__background {
  max-height: 100vh;
}

.content__item {
  position: relative;
  width: 100%;
  margin-top: 0;
  scroll-snap-align: start;
}
.content__item__section {
  position: relative;
}
.content__item__section.description {
  padding: 70px 0;
}
.content__item__section.description .section__copy {
  padding: 0 7.5%;
}
.content__item__section .section__copy {
  position: relative;
  z-index: 2;
}
.content__item__section .section__background {
  position: absolute;
  top: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  max-height: unset;
}
.content__item__section .section__background img, .content__item__section .section__background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-container {
  position: relative;
  height: inherit;
}
.carousel-container.autoplay.speed-1 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 1s;
}
.carousel-container.autoplay.speed-2 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 2s;
}
.carousel-container.autoplay.speed-3 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 3s;
}
.carousel-container.autoplay.speed-4 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 4s;
}
.carousel-container.autoplay.speed-5 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 5s;
}
.carousel-container.autoplay.speed-6 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 6s;
}
.carousel-container.autoplay.speed-7 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 7s;
}
.carousel-container.autoplay.speed-8 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 8s;
}
.carousel-container.autoplay.speed-9 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 9s;
}
.carousel-container.autoplay.speed-10 .flickity-page-dots .dot.is-selected:before {
  animation-duration: 10s;
}
.carousel-container.autoplay .flickity-page-dots .dot.is-selected:before {
  animation: 3s growRight forwards linear;
}
.carousel-container .content__item {
  height: 100%;
}
.carousel-container .carousel {
  overflow: hidden;
  height: 100%;
  outline: none;
}
.carousel-container .carousel.hidden {
  display: none;
}
.carousel-container .carousel::-webkit-scrollbar {
  height: 0px;
  width: 0px;
  background: transparent;
}
.carousel-container .carousel__item {
  position: relative;
  width: 100%;
  height: 100%;
  margin-top: 0;
  display: inline-block;
  opacity: 0;
  transition: opacity 1s ease-out;
}
.carousel-container .carousel__item.loaded {
  opacity: 1;
}
.carousel-container .carousel__item a {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 0;
  text-indent: unset;
  color: unset;
}
.carousel-container .carousel__item a:hover {
  background: unset;
}
.carousel-container .carousel__item__title {
  position: absolute;
  z-index: 2;
  font-size: 21px;
  bottom: 40px;
  left: 7%;
  cursor: pointer;
}
.carousel-container .carousel__item__title a {
  position: relative;
}
.carousel-container .carousel__item__title:hover .main {
  background-color: transparent;
  text-decoration: underline;
  text-underline-position: under;
  text-decoration-color: #55FF9E;
  color: #FFF;
}
@media (min-width: 970px) {
  .carousel-container .carousel__item__title {
    left: 3%;
  }
}
.carousel-container .carousel__item__title .main {
  background-color: #55FF9E;
  padding: 7px 7px 5px 7px;
  color: #000;
  margin-right: 10px;
  line-height: 30px;
}
.carousel-container .carousel__item__title .subtitle {
  position: relative;
  top: 1px;
  background-color: none !important;
  color: #FFF;
  vertical-align: bottom;
  line-height: 40px;
}
.carousel-container .carousel__item__title .subtitle a {
  text-decoration: none;
}
@media (max-width: 969px) {
  .carousel-container .carousel__item__title .subtitle {
    display: block;
    margin-top: 20px;
    line-height: 30px;
  }
}
.carousel-container .carousel__item__background {
  position: relative;
  width: 100%;
  height: 100%;
}
.carousel-container .carousel__item__background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carousel-container .carousel__item__background img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.carousel-container .flickity-page-dots {
  position: relative;
  z-index: 3;
  display: none;
  bottom: 15px;
}
@media (min-width: 1300px) {
  .carousel-container .flickity-page-dots {
    bottom: 20px;
  }
}
.carousel-container .flickity-page-dots .dot {
  opacity: 1;
  position: relative;
  border-radius: 12px;
  margin: 0 0.2vw;
  background: rgba(255, 255, 255, 0.3);
  height: 0.5vw;
  min-height: 5px;
}
.carousel-container .flickity-page-dots .dot:first-child {
  margin-left: 0;
}
.carousel-container .flickity-page-dots .dot:last-child {
  margin-right: 0;
}
.carousel-container .flickity-page-dots .dot.is-selected {
  background: rgba(255, 255, 255, 0.3);
}
.carousel-container .flickity-page-dots .dot.is-selected:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.6);
  pointer-events: none;
}

.hero {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-size: cover;
  background-position: center center;
}
.hero.offices p {
  margin: 80px 0 0 0.5vw;
}
.hero.offices .expand-icon {
  display: none;
}
.hero__content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: initial;
  color: #FFF;
  width: 100%;
  padding: 0 7.5%;
}
@media (min-width: 970px) {
  .hero__content .headline {
    font-size: 6vw;
    line-height: 6.5vw;
  }
}
.hero__content .headline, .hero__content p {
  color: #FFF;
}
@media (min-width: 970px) {
  .hero__content .headline, .hero__content p {
    display: block;
    margin: unset;
  }
}
.hero__content .headline {
  display: block;
}
@media (min-width: 970px) {
  .hero__content .headline:nth-child(2) {
    display: inline;
  }
}
@media (min-width: 970px) {
  .hero__content .copy {
    width: 95%;
    display: inline-block;
  }
}
.hero__content p {
  margin-top: 20px;
  display: block;
}
.hero__content p a {
  margin-bottom: 10px;
  color: #FFF !important;
  text-decoration-color: #FFF !important;
}
.hero__content p a:hover {
  color: #000 !important;
  text-decoration-color: #000 !important;
}

.text-block {
  padding: 60px 7.5%;
}
.text-block .headline {
  margin: 0;
}

.custom-slideshow {
  color: #FFF;
  min-height: 100vh;
}
.custom-slideshow .headline {
  margin-bottom: 20px;
}
.custom-slideshow__content {
  position: absolute;
  z-index: 2;
  padding: 0 7.5%;
  top: 50%;
  transform: translateY(-50%);
}
@media (min-width: 970px) {
  .custom-slideshow__content {
    width: 80%;
  }
}
@media (min-width: 970px) {
  .custom-slideshow__content p {
    width: 90%;
    margin: unset;
  }
}
.custom-slideshow__content span {
  font-size: 16px;
  line-height: 24px;
}
@media (min-width: 970px) {
  .custom-slideshow__content span {
    font-size: 24px;
    line-height: 32px;
    vertical-align: middle;
  }
}
.custom-slideshow .flickity-slider {
  transform: none !important;
}
.custom-slideshow .flickity-slider .slider__item {
  width: 100vw;
  height: 100vh;
  left: 0 !important;
  opacity: 0;
  transition: opacity 1s ease-out;
  z-index: -1;
  transform: none !important;
  pointer-events: none;
}
.custom-slideshow .flickity-slider .slider__item.is-selected {
  opacity: 1;
  z-index: 0;
}
.custom-slideshow .flickity-slider img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.custom-slideshow .flickity-page-dots {
  bottom: 50px;
}
.custom-slideshow .flickity-page-dots .dot {
  background: #FFF;
  opacity: 0.3;
}
.custom-slideshow .flickity-page-dots .dot.is-selected {
  background: #FFF;
  opacity: 0.8;
}

.instagram-feed__banner {
  padding: 80px 0;
  max-width: 670px;
  width: 100%;
}
.instagram-feed__banner img {
  width: 100%;
}

.page.home {
  position: relative;
  overflow: scroll;
  height: 100%;
  scroll-snap-type: mandatory;
  scroll-snap-points-y: repeat(100vh);
  scroll-snap-type: y mandatory;
  opacity: 0;
  animation: 1s fadeIn ease-in forwards;
}
.page.home .copy, .page.home .custom-slideshow .headline {
  cursor: pointer;
}
.page.home .copy:hover .expand-icon, .page.home .custom-slideshow .headline:hover .expand-icon {
  animation: bubble 1s;
  animation-timing-function: ease-out;
}
@keyframes bubble {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
.page.home::-webkit-scrollbar {
  height: 0px;
  width: 0px;
  background: transparent;
}
.page.home .expand-icon {
  display: block;
}
@media (min-width: 970px) {
  .page.home .expand-icon {
    display: inline-block;
  }
}

.page.about {
  padding-top: 5vw;
}
.page.about__section.top {
  height: 95vh;
}
.page.about .expanded {
  padding: 0 7.5%;
  background-color: #000;
  overflow: hidden;
}
.page.about .expanded .parallax {
  height: calc(100vh * var(--imageNum) - 200px);
}
@media (min-width: 970px) {
  .page.about .expanded .parallax {
    height: calc(600px * var(--imageNum));
  }
}
.page.about .expanded .parallax__copy {
  position: relative;
  z-index: 4;
}
@media (min-width: 970px) {
  .page.about .expanded .parallax__copy {
    width: 63%;
  }
}
.page.about .expanded .parallax__copy .link {
  font-size: 32px;
  cursor: pointer;
  margin-top: -2vh;
}
@media (min-width: 970px) {
  .page.about .expanded .parallax__copy .link {
    font-size: 40px;
  }
}
@media (max-height: 600px) {
  .page.about .expanded .parallax__copy .link {
    font-size: 25px;
    line-height: 32px;
  }
}
.page.about .expanded .parallax__copy .link:hover .expand-icon {
  animation: bubble 1s;
  animation-timing-function: ease-out;
}
@keyframes bubble {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(1.2);
  }
  70% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
}
.page.about .expanded .parallax__copy .link .expand-icon {
  display: block;
  width: 30px;
}
@media (min-width: 970px) {
  .page.about .expanded .parallax__copy .link .expand-icon {
    width: 40px;
    display: inline-block;
  }
}
.page.about .expanded .parallax__images {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100%;
  margin: 0 0 0 -7.5%;
  padding: 0;
}
.page.about .expanded .parallax__images:before {
  position: absolute;
  content: "";
  background: linear-gradient(180deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 100%);
  opacity: 0.75;
  width: 100%;
  height: 200px;
  z-index: 3;
}
.page.about .expanded .parallax__images:after {
  position: absolute;
  content: "";
  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 100%);
  width: 100%;
  height: 200px;
  z-index: 3;
  bottom: 0;
}
@media (min-width: 970px) {
  .page.about .expanded .parallax__images:after {
    bottom: 50px;
  }
}
.page.about .expanded .parallax__images .parallax-image {
  position: relative;
  background-size: cover;
  height: 100vh;
}
@media (min-width: 970px) {
  .page.about .expanded .parallax__images .parallax-image {
    height: 600px;
  }
}
.page.about .expanded .parallax__images .parallax-image:before {
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  z-index: 0;
}
.page.about .expanded p {
  position: relative;
  z-index: 2;
  font-weight: 400;
  margin: 12vh 0;
  font-size: 32px;
  line-height: 40px;
}
@media (min-width: 970px) {
  .page.about .expanded p {
    margin: 7vw 0;
    font-size: 40px;
    line-height: 45px;
  }
}
.page.about .expanded p b {
  color: #55FF9E;
  font-weight: 400;
  display: block;
}

:root {
  --imageNum: 0;
}

.page {
  width: 100%;
}
.page .expanded__bottom {
  position: relative;
  display: block;
  margin-top: 80px;
}
.page.culture .happenings img {
  width: 100%;
}
.page.culture .hero.edi {
  min-height: unset;
}
.page.culture .hero__content {
  position: relative;
  top: unset;
  left: unset;
  transform: unset;
  padding: 80px 7.5%;
}
.page.culture .hero .headline b {
  color: #55FF9E;
  font-weight: unset;
}
.page.culture .hero p {
  margin: 5vw 0;
}
@media (min-width: 970px) {
  .page.culture .hero p {
    width: 60%;
  }
}
.page.culture .hero a {
  background: #55FF9E;
  color: #000 !important;
  text-decoration: unset;
}
.page.culture .hero a:hover {
  color: #FFF !important;
  background: none;
  text-decoration: underline !important;
}
.page.terms-privacy {
  padding: 100px 10% 150px 10%;
}
.page.terms-privacy * {
  font-size: 18px;
  line-height: 24px;
  font-weight: unset;
}
.page.terms-privacy h1 {
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}
.page.terms-privacy h2, .page.terms-privacy h3 {
  margin: 10px 0;
  text-decoration: underline;
  font-weight: bold;
}
.page.terms-privacy p {
  margin: 0;
}
.page.terms-privacy ul {
  margin: 10px 0;
}
.page.terms-privacy li {
  margin-left: 20px;
}
.page.terms-privacy .footer {
  bottom: 0;
}
.page.list .content__item:nth-last-of-type(2) .expand-icon {
  bottom: -35px;
}
.page.home {
  height: 100%;
  min-height: unset;
}
.page.home .footer {
  margin-top: -70px;
}
@media (min-width: 970px) {
  .page.home .footer {
    margin-top: -90px;
  }
}
.page.strategy-studio .content__item.strategy-studio .headline {
  display: block;
  color: #FFF;
  font-size: 4vw;
  line-height: 4.5vw;
  transform: scale(0.8);
  transform-origin: left;
}
@media (max-width: 969px) {
  .page.strategy-studio .content__item.strategy-studio .headline {
    font-size: 40px;
    line-height: 45px;
  }
}
.page.strategy-studio .content__item.strategy-studio .headline:before {
  display: none;
}
.page.strategy-studio .content__item.strategy-studio .headline:first-child {
  font-size: 6vw;
  line-height: 5vw;
  transform: none;
}
@media (max-width: 969px) {
  .page.strategy-studio .content__item.strategy-studio .headline:first-child {
    font-size: 60px;
    line-height: 55px;
    margin-bottom: 20px;
  }
}
.page.strategy-studio .content__item.strategy-studio .headline:nth-child(n+3):nth-child(-n+7) {
  line-height: 3vw;
  white-space: nowrap;
}
@media (max-width: 969px) {
  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(n+3):nth-child(-n+7) {
    white-space: unset;
    font-size: 30px;
    line-height: 35px;
    margin-bottom: 20px;
  }
}
.page.strategy-studio .content__item.strategy-studio .headline:nth-child(2) {
  margin-bottom: 3vw;
  transform: scale(0.6);
  white-space: nowrap;
}
@media (max-width: 969px) {
  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(2) {
    white-space: unset;
    transform: scale(1);
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 50px;
  }
}
@media (max-width: 969px) {
  .page.strategy-studio .content__item.strategy-studio .headline {
    transform: scale(1);
  }
}
.page.strategy-studio .content__item.strategy-studio .headline:nth-child(8) {
  display: block;
  padding-top: 4vw;
}
@media (max-width: 969px) {
  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(8) {
    font-size: 30px;
    line-height: 35px;
  }
}
.page.strategy-studio .content__item.strategy-studio .headline:nth-child(8):after {
  content: "";
  position: absolute;
  transform: rotate(90deg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  width: 30px;
  height: 26px;
  bottom: 5px;
  margin-left: 10px;
  filter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);
}
@media (min-width: 970px) {
  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(8):after {
    margin-left: 20px;
    width: 60px;
    height: 52px;
    bottom: 20px;
  }
}
.page.strategy-studio .content__item.strategy-studio-contact .top {
  padding-top: 0;
}
.page.strategy-studio .content__item.strategy-studio-contact .top p {
  display: block;
  padding-left: 0;
  width: unset;
}
.page.strategy-studio .content__item__section.top {
  padding: 140px 7.5% 80px 7.5%;
}
.page.strategy-studio .content__item__section.expanded {
  padding: 80px 7.5%;
  background-color: #000;
}
.page.strategy-studio .content__item__section.expanded p {
  position: relative;
  z-index: 2;
  font-weight: 400;
  margin: 0 0 12vh 0;
  font-size: 32px;
  line-height: 40px;
}
@media (min-width: 970px) {
  .page.strategy-studio .content__item__section.expanded p {
    margin: 0 0 7vw 0;
    font-size: 40px;
    line-height: 45px;
  }
  .page.strategy-studio .content__item__section.expanded p:last-child {
    margin-bottom: 0;
  }
}
.page.strategy-studio .content__item__section.expanded p b {
  color: #55FF9E;
  font-weight: 400;
  display: block;
}
.page .embedded__media {
  position: relative;
  height: 100%;
}
.page .embedded__media__description {
  position: absolute;
  padding: 20px;
  transition: 0.2s all ease-out;
  opacity: 0;
  pointer-events: none;
  width: calc(100% - 20px);
  height: 100%;
  white-space: pre-wrap;
}
.page.close-visible:before {
  content: "";
  position: fixed;
  z-index: 3;
  height: 100px;
  width: 100%;
  bottom: 0;
  background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.2));
  pointer-events: none;
}
.page__section {
  position: relative;
  width: 100%;
}
.page__section.expanded img {
  width: 100%;
}
.page__section.expanded video {
  width: 100%;
}
.page__section.expanded .back-btn, .page__section.expanded .more-btn {
  position: absolute;
  display: inline-block;
}
.page__section.expanded .back-btn a, .page__section.expanded .more-btn a {
  background-color: #55FF9E;
  padding: 7px 7px 5px 7px;
}
.page__section.expanded .back-btn a:hover, .page__section.expanded .more-btn a:hover {
  background-color: unset;
}
.page__section.expanded .back-btn {
  left: 0;
}
.page__section.expanded .more-btn {
  right: 0;
}
@media (min-width: 970px) {
  .page__section.top {
    margin-top: 100px;
  }
}
@media (min-width: 1800px) {
  .page__section.top .headline br {
    content: " ";
  }
  .page__section.top .headline br:after {
    content: " ";
  }
}
.page__section.top .headline:nth-child(3) {
  display: block;
  padding-top: 4vw;
}
.page__section.top .headline:nth-child(3):after {
  content: "";
  position: absolute;
  transform: rotate(90deg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  width: 30px;
  height: 26px;
  bottom: 5px;
  margin-left: 10px;
  filter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);
}
@media (min-width: 970px) {
  .page__section.top .headline:nth-child(3):after {
    margin-left: 20px;
    width: 60px;
    height: 52px;
    bottom: 20px;
  }
}
.page__section.top .copy {
  padding: 70px 7.5%;
  margin-top: 50px;
}
@media (min-width: 970px) {
  .page__section.top .copy {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin-top: -50px;
  }
}
.page__section.top .copy p {
  margin-top: 20px;
}
@media (min-width: 970px) {
  .page__section.top .copy p {
    margin-top: 40px;
  }
}
.page__section.embed {
  padding: 70px 7.5%;
}
.page__section.embed:empty {
  display: none;
}
.page__section.embed .copy {
  padding: 0;
}
.page__section .section__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.page__section .section__background img, .page__section .section__background video {
  width: 100vw;
  height: 100%;
  object-fit: cover;
}
.page__section .content {
  padding: 0 5%;
}
.page__section .client-name {
  margin: 20px auto;
}
@media (min-width: 970px) {
  .page__section .client-name {
    margin: 0;
    display: block;
    width: 50%;
  }
}
.page__section.top {
  display: inline-block;
  transition: 0.3s all ease-out;
  padding-top: 100px;
  height: 100vh;
}
.page__section .content img {
  width: 100%;
}
.page__section .copy, .page__section .content {
  position: relative;
  margin: auto;
  z-index: 2;
}
.page .close {
  position: fixed;
  bottom: 30px;
}

.page.work {
  height: unset;
}
@media (min-width: 970px) {
  .page.work {
    padding-bottom: 40px;
  }
}
.page.work .hero {
  margin-bottom: 10px;
}
.page.work .footer {
  position: absolute;
  bottom: -130px;
}
@media (min-width: 970px) {
  .page.work .footer {
    bottom: -60px;
  }
}
.page.work .content__item {
  padding: 10px 20px;
}
.page.work .content__item:hover .section__background .embedded__media .embedded__media__description {
  opacity: 1;
}
.page.work .content__item .description {
  height: unset;
  padding-bottom: 40vw;
}
.page.work .page__section.top {
  display: none;
}
.page.work .page__section .client-name {
  margin-bottom: 5px;
}
@media (min-width: 970px) {
  .page.work .page__section .client-name {
    padding-left: 40px;
    margin-bottom: 0px;
  }
}
.page.work .section__background {
  min-height: unset;
}
.page.work .section__background .embedded__media {
  height: 100%;
}
.page.work .section__background .embedded__media .embedded__media__description {
  background: rgba(0, 0, 0, 0.4);
  color: #FFF;
  width: 100%;
}
.page.work .section__background .embedded__media .embedded__media__description .client {
  font-weight: bold;
}
.page.work .expanded {
  padding: 120px 20px 50px 20px !important;
  max-width: 1800px;
  margin: auto;
}
@media (max-width: 969px) {
  .page.work .expanded {
    padding-top: 80px !important;
    padding-bottom: 0 !important;
  }
}
.page.work .expanded p {
  margin-top: 10px;
}
.page.work .expanded .embedded__media {
  margin: 20px 0;
  display: grid;
}
.page.work .expanded .embedded__media img {
  order: 1;
}
.page.work .expanded .embedded__media .caption {
  order: 2;
}
.page.work .expanded .headline {
  display: inline-block;
  margin-left: -2px;
  margin-bottom: 0px;
}
@media (min-width: 970px) {
  .page.work .expanded .headline {
    width: 60%;
    margin-left: -5px;
    padding: 0 5% 0 40px;
    vertical-align: top;
  }
}
.page.work .expanded p {
  display: inline-block;
  margin: 20px 0;
}
@media (min-width: 970px) {
  .page.work .expanded p {
    width: 35%;
  }
}
@media (min-width: 1800px) {
  .page.work .expanded p {
    width: 40%;
    padding-left: 20px;
  }
}

.contact {
  min-height: 100vh;
  color: #FFF;
  background-size: cover;
}
.contact__content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: initial;
  color: #FFF;
  width: 100%;
  padding: 13vh 7.5% 0 7.5%;
}
.contact__content .header-copy {
  margin-bottom: 2vh;
}
.contact .headline {
  width: 100%;
}
@media (min-width: 970px) {
  .contact .headline {
    width: 60%;
  }
}
.contact p {
  margin: unset;
}
@media (min-width: 970px) {
  .contact p {
    width: 70%;
  }
}
.contact__column {
  width: 100%;
  display: inline-block;
  vertical-align: top;
  margin-bottom: 2vh;
}
.contact__column.full-width {
  width: 100%;
}
@media (min-width: 970px) {
  .contact__column.full-width {
    width: 40%;
  }
}
@media (min-width: 970px) {
  .contact__column {
    margin: 40px 0;
  }
}
@media (min-width: 970px) {
  .contact__column {
    width: 27.5%;
  }
}
.contact__column p {
  width: 100%;
}
@media (max-width: 969px) {
  .contact__column p {
    font-size: 15px;
    line-height: 18px;
  }
}
@media (min-width: 970px) {
  .contact__column p {
    font-size: 1.4vw;
    line-height: 1.8vw;
  }
}
.contact__column a {
  color: #FFF;
  text-decoration: none;
  padding: 0;
}
.contact__column a:hover {
  text-decoration: underline;
  background: none;
}
.contact__column .column__title {
  font-size: 15px;
  font-weight: 700;
}
@media (min-width: 970px) {
  .contact__column .column__title {
    margin-bottom: 10px;
    font-size: 1.4vw;
    line-height: 1.8vw;
  }
}

.page.news {
  padding: 0 20px 20px 20px;
}
.page.news .hero {
  height: 100vh !important;
  width: 100vw !important;
  margin: 0 0 40px -20px !important;
}
.page.news .expanded {
  display: none;
}
.page.news .content__item {
  width: 100%;
  height: 70vw;
  padding: 0 20px 20px 20px;
  min-height: unset;
  margin-bottom: 20px;
}
@media (min-width: 970px) {
  .page.news .content__item.size-2 {
    width: 100%;
    height: 40vw;
  }
}
@media (min-width: 970px) {
  .page.news .content__item.size-1 {
    width: 50%;
    height: 50vw;
    display: inline-block;
  }
}
.page.news .content__item .copy {
  font-family: "PPNeueMachina";
  display: block;
  padding: 0;
}
@media (min-width: 970px) {
  .page.news .content__item .copy {
    padding: 0 40px 20px 40px;
  }
}
.page.news .content__item .copy p {
  width: unset;
  margin-top: 0;
}
.page.news .content__item .copy p:nth-child(1), .page.news .content__item .copy p:nth-child(2) {
  display: inline-block;
  width: 50%;
}
@media (min-width: 970px) {
  .page.news .content__item .copy p:nth-child(1), .page.news .content__item .copy p:nth-child(2) {
    width: 25%;
  }
}
.page.news .content__item .copy p:nth-child(2) {
  text-align: right;
}
@media (min-width: 970px) {
  .page.news .content__item .copy p:nth-child(2) {
    text-align: left;
    width: 25%;
    display: inline-block;
  }
}
@media (min-width: 970px) {
  .page.news .content__item .copy p:nth-child(3) {
    text-align: left;
    width: 50%;
    display: inline-block;
  }
}
.page.news .content__item .copy b {
  color: #000;
  font-weight: bold;
  display: inline-block;
  background: none;
}
.page.news .content__item .copy i {
  display: inline-block;
  color: #000;
  opacity: 0.6;
  font-style: unset;
}
.page.news .content__item .section__background {
  position: relative;
  min-height: unset;
  height: 40vw;
}
.page.news .news__item {
  position: relative;
}
.page.news .news__item a {
  position: absolute;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  z-index: 3;
}
.page.news .news__item a:hover {
  background-color: unset;
}
.page.news .news__item:hover .news__item__content__title {
  background-color: #55FF9E;
  color: #000;
}
.page.news .news__item__content {
  position: absolute;
  bottom: 40px;
  left: 50px;
}
@media (min-width: 970px) {
  .page.news .news__item__content {
    bottom: 80px;
    left: 80px;
  }
}
.page.news .news__item__content__info {
  color: #FFF;
}
.page.news .news__item__content__info .source {
  font-weight: bold;
  margin-right: 30px;
  margin-right: 60px;
  display: block;
}
.page.news .news__item__content__info .date {
  font-size: 12px;
}
.page.news .news__item__content__title {
  display: inline-block;
  margin: 10px 0 0 -10px;
  padding: 5px 10px;
  background-color: unset;
  text-decoration: underline;
  text-decoration-color: #55FF9E;
  text-underline-position: under;
  color: #FFF;
}
@media (max-width: 969px) {
  .page.news .news__item__content__title {
    background-color: #55FF9E;
    color: #000;
  }
}
.page.news .news__item__background {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.page.culture .page__section.expanded, .page.our-energy .page__section.expanded {
  padding: 10px;
  background-color: #f8f8f2;
  padding: 20px;
  margin-right: 40px;
  background-color: #F8F8F3;
}
.page.culture .page__section.expanded .culture__grid, .page.our-energy .page__section.expanded .culture__grid { /* Not needed if autoprefixing */ /* Not needed if autoprefixing */
  display: flex;
  margin-left: -20px; /* gutter size offset */
  width: auto;
}
.page.culture .page__section.expanded .culture__grid .grid__item, .page.our-energy .page__section.expanded .culture__grid .grid__item {
  padding-left: 20px; /* gutter size */
}
@media (max-width: 969px) {
  .page.culture .page__section.expanded .culture__grid .grid__item, .page.our-energy .page__section.expanded .culture__grid .grid__item {
    width: 100% !important;
  }
}
@media (min-width: 1300px) {
  .page.culture .page__section.expanded .culture__grid .grid__item, .page.our-energy .page__section.expanded .culture__grid .grid__item {
    width: auto;
  }
}
.page.culture .page__section.expanded .culture__grid .culture__item:before, .page.our-energy .page__section.expanded .culture__grid .culture__item:before {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #f8f8f2;
  pointer-events: none;
  content: "";
  z-index: 2;
  opacity: 0;
  transition: 0.3s opacity ease-out;
}
.page.culture .page__section.expanded .culture__grid .culture__item.active:before, .page.our-energy .page__section.expanded .culture__grid .culture__item.active:before {
  opacity: 1;
}
.page.culture .page__section.expanded img, .page.our-energy .page__section.expanded img {
  display: inherit;
  width: 100%;
}
.page.culture .page__section.expanded .embed, .page.our-energy .page__section.expanded .embed {
  padding: 10px;
}
.page.culture .page__section.expanded .embed a:hover, .page.our-energy .page__section.expanded .embed a:hover {
  color: unset;
  background-color: unset;
}
.page.culture .page__section.expanded .embed .section__background, .page.our-energy .page__section.expanded .embed .section__background {
  position: relative;
}
.page.culture .culture__item, .page.our-energy .culture__item {
  position: relative;
  cursor: pointer;
  margin-bottom: 20px;
}
.page.culture .culture__item__description, .page.our-energy .culture__item__description {
  position: absolute;
  padding: 10px;
  width: 100%;
  height: 100%;
  transition: 0.2s all ease-out;
}
.page.culture .culture__item__description:hover, .page.our-energy .culture__item__description:hover {
  background: rgba(0, 0, 0, 0.2);
}
.page.culture .culture__item__description h2, .page.culture .culture__item__description p, .page.our-energy .culture__item__description h2, .page.our-energy .culture__item__description p {
  font-size: 16px;
  line-height: 26px;
  margin: 0;
  color: #FFF;
}
.page.culture .culture__item__description h2 u, .page.culture .culture__item__description p u, .page.our-energy .culture__item__description h2 u, .page.our-energy .culture__item__description p u {
  color: #FFF;
}
.page.culture .culture__item__description h2 u:after, .page.culture .culture__item__description p u:after, .page.our-energy .culture__item__description h2 u:after, .page.our-energy .culture__item__description p u:after {
  background-color: #FFF;
}
.page.culture .people__list__item__description, .page.our-energy .people__list__item__description {
  left: 15px;
}

.partners {
  height: 100vh;
}
.partners__content {
  padding: 0 7.5%;
  padding-top: 5vh;
}
.partners__content p {
  width: 100%;
  margin: unset;
}
@media (min-width: 1300px) {
  .partners__content p {
    width: 60%;
  }
}
@media (min-width: 1300px) {
  .partners__logos {
    margin-top: 5vh;
  }
}
.partners__logos img {
  width: 25%;
  display: inline-block;
  transform-origin: top left;
  margin-bottom: -5vw;
  max-width: 150px;
}
@media (min-width: 1300px) {
  .partners__logos img {
    margin-bottom: 0;
    max-width: 220px;
    max-height: 10.5vw;
    width: auto;
  }
}
@media (min-width: 1800px) {
  .partners__logos img {
    margin-bottom: 0;
    width: auto;
  }
}

.people__list {
  padding: 0 7.5%;
  font-size: 0;
  padding: 80px 40px;
}
.people__list__item {
  position: relative;
  width: 100%;
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
}
.people__list__item a {
  width: 100%;
  height: 100%;
  background: none;
  text-decoration: none;
  display: inline-block;
  padding: 0;
}
.people__list__item:hover .people__list__item__description {
  opacity: 1;
}
.people__list__item__description {
  position: absolute;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5);
  color: #FFF;
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  opacity: 0;
  transition: 0.5s opacity ease-out;
  pointer-events: none;
  top: 20px;
  left: 20px;
}
.people__list__item__description .description__copy {
  position: absolute;
  left: 30px;
  bottom: 40px;
}
.people__list__item__description p {
  line-height: 24px;
  margin-top: 0;
}
@media (max-width: 969px) {
  .people__list__item__description p {
    line-height: 18px;
  }
}
.people__list__item__description p.role {
  font-weight: bold;
  margin-top: 10px;
}
.people__list__item img {
  width: 100%;
  display: inline-block;
  padding: 20px;
}
@media (min-width: 970px) {
  .people__list__item {
    width: 33.3333333333%;
  }
}

.anti-racism .expand-cta {
  position: absolute;
  z-index: 3;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10vh;
  font-size: 20px;
  background: #55FF9E;
  display: inline-block;
  padding: 5px;
  color: #000;
  cursor: pointer;
}
.anti-racism .expand-cta:hover {
  background: #000;
  color: #FFF;
}
.anti-racism .hero {
  transition: 0.5s ease-out all;
}
.anti-racism .hero__content {
  position: relative;
  padding-top: 20vh;
  margin-bottom: 60px;
  top: unset;
  left: unset;
  transform: unset;
}
.anti-racism.expanded .hero {
  min-height: 50vh;
}
.anti-racism.expanded .expand-cta {
  bottom: 30px;
}
.anti-racism .page__section__top {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.anti-racism .expanded-content {
  position: relative;
  height: 0;
  padding: 0 7.5%;
  overflow: hidden;
  transition: 0.3s ease-out height;
}
.anti-racism .expanded-content.expanded {
  padding: 0 7.5% 120px 7.5%;
  height: auto;
}
.anti-racism .expanded-content.expanded .expanded {
  bottom: 0px;
}

.partners {
  padding-bottom: 0 !important;
}
.partners .headline {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  background-color: #55FF9E;
  color: #000;
  line-height: 50px;
  white-space: nowrap;
  text-transform: uppercase;
  animation: 8s marquee linear infinite;
  cursor: default;
  overflow-x: hidden;
  display: inline-block;
}
@media (min-width: 970px) {
  .partners .headline {
    animation: 3s marqueeDesktop linear infinite;
    line-height: 80px;
  }
}
.partners .headline b {
  display: unset;
}
.partners .headline:before {
  content: "Our proud partners ↓";
  padding-right: 12px;
}
@media (min-width: 970px) {
  .partners .headline:before {
    padding-right: 20px;
  }
}
.partners .headline:after {
  content: "Our proud partners ↓";
  padding-left: 12px;
}
@media (min-width: 970px) {
  .partners .headline:after {
    padding-right: 20px;
  }
}
.partners .headline:empty {
  display: none;
}
.partners .embedded__media {
  width: 25%;
  display: inline-block;
  padding: 20px 0;
}
@media (min-width: 1300px) {
  .partners .embedded__media {
    width: 14.2857142857%;
  }
}

.map {
  position: relative;
  padding: 0 !important;
}
.map .headline {
  position: relative;
  width: 100%;
  padding: 60px 7.5%;
  color: #FFF;
  background: linear-gradient(270deg, rgb(251, 98, 48) 0%, rgb(252, 91, 65) 40%, rgb(252, 120, 79) 60%, rgb(252, 169, 54) 100%);
}

.lazyload-wrapper {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/_global.scss","webpack://./src/styles/_app.scss","webpack://./src/styles/_nav.scss","webpack://./src/styles/_footer.scss","webpack://./src/styles/_banner.scss","webpack://./src/styles/_content.scss","webpack://./src/styles/_carousel.scss","webpack://./src/styles/_hero.scss","webpack://./src/styles/_textblock.scss","webpack://./src/styles/_custom-slideshow.scss","webpack://./src/styles/_instagram-feed.scss","webpack://./src/styles/_home.scss","webpack://./src/styles/_about.scss","webpack://./src/styles/_page.scss","webpack://./src/styles/_work.scss","webpack://./src/styles/_contact.scss","webpack://./src/styles/_news.scss","webpack://./src/styles/_culture.scss","webpack://./src/styles/_partners.scss","webpack://./src/styles/_people.scss","webpack://./src/styles/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACQhB;EACE,SAAA;EACA,UAAA;EAEA,0BAAA;EAEA,sBAAA;ADLF;;ACQA;EACE,SAAA;EACA,UAAA;EACA,YAAA;ADLF;;ACQA;EACE,8BAAA;ADLF;;ACQA;EACC,mBAtBM;EAuBN,gBAAA;EACC,4BAAA;EACA,kCAAA;ADLF;;ACQA;EACC,gBAAA;ADLD;;ACQA;EACC,kBAAA;ADLD;;AC8CA;EACC,2BAAA;AD3CD;AC4CC;EACC,gBAAA;EACA,UAAA;AD1CF;AC2CE;EACC,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ADzCH;AC0CG;EACC,WAAA;ADxCJ;ACyCI;EACC,aAAA;EACA,gBAAA;ADvCL;ACLI;EAgDF;IAEG,kBAAA;IACC,UAAA;IACA,qBAAA;IACA,mBAAA;EDzCJ;AACF;;AC+CE;EACE,sBAAA;AD5CJ;;ACgDA;EACC,cAAA;AD7CD;AC8CE;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EAaC,iBAAA;ADxDJ;AC4CG;EACC,gBAAA;AD1CJ;AC9BI;EAmEF;IAQE,kCAAA;IACA,6BAAA;IACA,qBAAA;IACA,mBAAA;EDzCF;EC0CE;IACC,0BAAA;EDxCH;AACF;AC4CE;EACC,WAAA;EACA,gBAAA;AD1CH;AC2CG;EACC,0BAAA;ADzCJ;AC8CG;EACC,sBAAA;AD5CJ;AC8CG;EACC,yBAAA;AD5CJ;;ACuFA;EACC,gCAAA;EACA,gBAAA;EACA,kBAAA;ADpFD;;ACuFA;EACC,YAAA;ADpFD;;ACuFA;EACC,eAAA;ADpFD;;AC2FA;EACC,gCAAA;EACA,kBAAA;EACA,kBAAA;EACC,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;ADxFF;ACyFE;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;ADvFF;ACpFI;EA+JJ;IAeG,cAAA;IACA,kBAAA;IACA,qBAAA;IACA,sBAAA;EDtFD;AACF;;ACyFA;EACC,eAAA;EAEA,uBAAA;EACA,uBAAA;ADvFD;AClGI;EAqLJ;IAME,eAAA;IACA,kBAAA;EDrFA;AACF;;ACwFA;EACC,cAAA;ADrFD;;ACwFA;EACC,qBAAA;ADrFD;;ACwFA;EACC,kBAAA;EACA,UAAA;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ADrFF;ACsFE;EACC,0BAAA;ADpFH;ACsFE;EACC,aAAA;ADpFH;ACsFE;EACC,wBAAA;ADpFH;ACnII;EAwMJ;IAmBG,eAAA;IACA,iBAAA;IACA,sBAAA;EDpFD;AACF;;ACwFC;EACE,aAAA;ADrFH;;ACyFA;EACC,aAAA;ADtFD;;ACyFA;EA/EC,eAAA;EAiFA,+FAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;ADtFD;ACuFE;EAlHD,oBAAA;EACC,mCAAA;AD8BF;AC7BC;EACC;IAAK,mBAAA;EDgCL;EC/BA;IAAM,qBAAA;EDkCN;ECjCA;IAAM,qBAAA;EDoCN;ECnCA;IAAM,qBAAA;EDsCN;ECrCA;IAAO,mBAAA;EDwCP;AACF;AClLI;EA2OJ;IAaE,kBAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,kBAAA;EDlEA;AACF;;ACqEA;EACC,kBAAA;EACA,8BAjTO;EAkTP,8BAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;ADlED;ACmEC;EACE,0BAAA;ADjEH;ACmEC;EACC,yBA1TM;ADyPR;ACkEE;EACC,aAAA;ADhEH;ACqEE;EACC,uBAAA;ADnEH;;ACwEA;EACC,WAAA;EAjLA,6HAAA;AD6GD;ACqEC;EACC,WAAA;ADnEF;ACoEE;EACC,WAAA;ADlEH;ACqEC;EACC,cAhVM;AD6QR;ACqEC;EACC,WAAA;ADnEF;;ACwEA;EACC,WAAA;EACA,sBAAA;ADrED;ACsEC;EACC,WAAA;ADpEF;ACqEE;EACC,WAAA;ADnEH;ACsEC;EACC,cAlWM;AD8RR;ACsEC;EACC,WAAA;ADpEF;;ACwEA;EACC,WAAA;EAYA,yBAAA;ADhFD;ACqEC;EACC,WAAA;ADnEF;ACqEC;EACC,cA9WO;AD2ST;ACsEC;EACC,WAAA;ADpEF;;AC0EA;EACC;IAAO,aAAA;EDtEN;ECuEA;IAAO,iBAAA;EDpEP;ECqEA;IAAO,iBAAA;EDlEP;ECmEA;IAAO,SAAA;EDhEP;AACF;ACkEA;EACC;IAAK,UAAA;ED/DJ;ECgED;IAAO,UAAA;ED7DN;AACF;AC+DA;EACC;IAAK,UAAA;ED5DJ;EC6DD;IAAO,UAAA;ED1DN;AACF;AC4DA;EACC;IACC,QAAA;ED1DA;EC4DD;IACC,WAAA;ED1DA;AACF;AEzVA;EACE,kBAAA;EACA,WAAA;AF2VF;AE1VE;EACE,YAAA;AF4VJ;AE1VE;EACE,WAAA;EACA,uEAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AF4VJ;AExVI;EACE,6BAAA;AF0VN;AC5TI;EC/BA;IAGI,6BAAA;EF4VN;AACF;;AGnXA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AHsXF;AGnXI;EACE,aAAA;AHqXN;AG/WU;EACE,sBAAA;AHiXZ;AG9WQ;EACE,yBFhBD;ADgYT;AG1WG;EACC,YAAA;EACA,qBAAA;AH4WJ;AG3WI;EACE,gBAAA;AH6WN;AGzWE;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;EACA,UAAA;AH2WJ;AChVI;EElCF;IASI,WAAA;EH6WJ;AACF;AG3WI;EACE,6BAAA;AH6WN;AG1WI;EACE,WAAA;AH4WN;AGxWE;EACE,eAAA;AH0WJ;AChXI;EEKF;IAII,eAAA;EH2WJ;AACF;AG1WI;EACE,eAAA;EACA,2BAAA;EACA,MAAA;EF0FL,6HAAA;EExFK,iBAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;AH4WN;AC/XI;EEWA;IAUI,YAAA;EH8WN;AACF;AG5WM;EACE,0CAAA;AH8WR;ACvYI;EEwBE;IAGI,0CAAA;EHgXR;AACF;AG7WM;EACE,WAAA;EACA,kBAAA;EAEA,gBAAA;EACA,kBAAA;AH8WR;AG5WQ;EACE,eAAA;EACA,UAAA;EACA,gBAAA;AH8WV;AG5WU;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,0BAAA;AH8WZ;AG1WQ;EACE,eAAA;AH4WV;AG1WU;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AH4WZ;AG3WY;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AH6Wd;AC9aI;EE6DQ;IAOI,eAAA;IACA,UAAA;EH8Wd;AACF;AG3WY;EACE,WAAA;AH6Wd;ACvbI;EEyDM;IAoBI,eAAA;IACA,cAAA;EH8WZ;AACF;AG1WQ;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AH4WV;AG1WU;EACE,aAAA;AH4WZ;AGzWU;EACE,gBAAA;AH2WZ;AGxWU;EACE,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AH0WZ;AGtWY;EACE,WAAA;AHwWd;AGjWI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;EACA,WAAA;AHmWN;AG/VU;EACE,0BAAA;AHiWZ;AG/VU;EACE,2BAAA;AHiWZ;AG3VQ;EACE,sBAAA;AH6VV;AG5VU;EACE,QAAA;EACA,wBAAA;AH8VZ;AG5VU;EACE,QAAA;EACA,yBAAA;AH8VZ;AGzVM;EACE,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;AH2VR;AGzVQ;EACE,MAAA;EACA,OAAA;AH2VV;AGxVQ;EACE,SAAA;EACA,OAAA;AH0VV;;AIhjBA;EACC,kBAAA;EACA,OAAA;EACA,UAAA;EACA,yBHHQ;EGIR,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAVc;EAWd,wDAAA;EACA,eAAA;EACA,UAAA;EACA,iCAAA;AJmjBD;AIjjBC;EACC,UAAA;AJmjBF;ACnhBI;EG/CJ;IAmBE,kBAAA;IACA,aAAA;IACA,YAxBc;IAyBd,eAAA;EJmjBA;AACF;AIjjBC;EACC,UAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;AJmjBF;ACxiBI;EGhBH;IAQE,aAAA;EJojBD;AACF;AIljBE;EACC,mBAAA;AJojBH;AInjBG;EACC,WAAA;EACA,UAAA;EACA,2BAAA;EACA,qBAAA;AJqjBJ;AIpjBI;EACC,iBAAA;AJsjBL;AIjjBE;EACC,kBAAA;EACA,UAAA;EACA,UAAA;AJmjBH;AC9jBI;EGQF;IAKE,UAAA;EJqjBF;AACF;AInjBG;EACC,cAAA;EACA,mBAAA;AJqjBJ;ACjkBI;EGUD;IAIE,qBAAA;IACA,SAAA;EJujBH;EItjBG;IACC,oBAAA;EJwjBJ;AACF;AIpjBG;EACC,gBAAA;EACA,mBAAA;AJsjBJ;AInjBG;EACC,cAAA;EACA,gBAAA;AJqjBJ;ACxlBI;EGiCD;IAIE,iBAAA;EJujBH;AACF;ACvlBI;EG2BD;IAOE,gBAAA;IACA,qBAAA;EJyjBH;AACF;AIxjBI;EACC,cAAA;EACA,YAAA;AJ0jBL;AIzjBK;EACC,UAAA;EACA,0BAAA;AJ2jBN;AIrjBE;EACC,iBAAA;EACE,UAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,qBAAA;AJujBL;AC7mBI;EGgDF;IAQE,kBAAA;EJyjBF;AACF;ACxnBI;EGsDF;IAWE,iBAAA;IACA,UAAA;IACA,mBAAA;EJ2jBF;EI1jBE;IACC,kBAAA;EJ4jBH;AACF;AI1jBG;EH0FF,eAAA;EGxFG,qBAAA;AJ4jBJ;AChoBI;EGkED;IAIE,kBAAA;EJ8jBH;AACF;AI7jBI;EACC,0BAAA;AJ+jBL;;AK1rBA;EACE,eAAA;AL6rBF;;AK1rBA;EACE;IACE,cAAA;EL6rBF;EK3rBA;IACE,8BAAA;EL6rBF;AACF;AK1rBA;EACE;IACE,cAAA;EL4rBF;EK1rBA;IACE,8BAAA;EL4rBF;AACF;AKzrBA;EAEC,yBJrBO;EIsBN,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;AL0rBF;AChpBI;EIpDJ;IAaI,aAAA;IACA,4CAAA;IACA,eAAA;IACA,iBAAA;EL2rBF;AACF;AKzrBE;EACE,iBAAA;AL2rBJ;;AMttBI;EACE,UAAA;ANytBN;AMrtBI;EACE,aAAA;ANutBN;AMttBM;ELgJJ,QAAA;EAGA,2BAAA;ADykBF;AM1tBU;EACE,kGAAA;EACA,gBAAA;AN4tBZ;ACpsBI;EK1BM;IAKI,gBAAA;IACA,gBAAA;EN6tBZ;AACF;AMptBM;EACE,yBAAA;ANstBR;AMptBM;EACE,YAAA;EACA,cAAA;ANstBR;AMntBQ;EACE,oBAAA;ANqtBV;AMhtBI;EACE,iBAAA;ANktBN;;AM7sBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,wBAAA;ANgtBF;AM/sBE;EACE,kBAAA;ANitBJ;AM/sBI;EACE,eAAA;ANitBN;AM/sBM;EACE,eAAA;ANitBR;AM5sBI;EACE,kBAAA;EACA,UAAA;AN8sBN;AM3sBI;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AN6sBN;AM3sBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AN6sBR;;AO3yBA;EACE,kBAAA;EACA,eAAA;AP8yBF;AOxyBU;EACE,sBAAA;AP0yBZ;AO/xBU;EACE,sBAAA;APiyBZ;AOtxBU;EACE,sBAAA;APwxBZ;AO7wBU;EACE,sBAAA;AP+wBZ;AOpwBU;EACE,sBAAA;APswBZ;AO3vBU;EACE,sBAAA;AP6vBZ;AOlvBU;EACE,sBAAA;APovBZ;AOzuBU;EACE,sBAAA;AP2uBZ;AOhuBU;EACE,sBAAA;APkuBZ;AOvtBU;EACE,uBAAA;APytBZ;AO9sBU;EACE,uCAAA;APgtBZ;AOzsBE;EACE,YAAA;AP2sBJ;AOxsBE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;AP0sBJ;AOxsBI;EACE,aAAA;AP0sBN;AOvsBI;EACE,WAAA;EACA,UAAA;EACA,uBAAA;APysBN;AOtsBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,+BAAA;APwsBN;AOtsBM;EACE,UAAA;APwsBR;AOrsBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;APusBR;AOrsBQ;EACC,iBAAA;APusBT;AOnsBM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;APqsBR;AOpsBQ;EACC,kBAAA;APssBT;AOnsBQ;EACC,6BAAA;EACA,0BAAA;EACA,8BAAA;EACA,8BNjMD;EMkMC,WAAA;APqsBT;ACx1BI;EMmIE;IAoBG,QAAA;EPqsBP;AACF;AOpsBQ;EACC,yBNzMD;EM0MC,wBAAA;EACA,WAAA;EACA,kBAAA;EACC,iBAAA;APssBV;AOpsBQ;EACC,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;APssBT;AOrsBS;EACC,qBAAA;APusBV;ACr3BI;EMsKI;IAWE,cAAA;IACA,gBAAA;IACA,iBAAA;EPwsBR;AACF;AOpsBM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;APssBR;AOpsBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;APssBV;AOnsBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;APqsBV;AO/rBE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;APisBJ;ACz3BI;EMoLF;IAOI,YAAA;EPksBJ;AACF;AOhsBI;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,aAAA;EACA,eAAA;APksBN;AOhsBM;EACE,cAAA;APksBR;AO/rBM;EACE,eAAA;APisBR;AO9rBM;EACE,oCAAA;APgsBR;AO9rBQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,oBAAA;APgsBV;;AQ/9BA;EACC,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kCAAA;ARk+BD;AQ/9BE;EACC,sBAAA;ARi+BH;AQ/9BE;EACC,aAAA;ARi+BH;AQ79BC;EACC,kBAAA;EP6IA,SAAA;EACA,QAAA;EAGA,gCAAA;EO/IA,kBAAA;EACE,WAAA;EACA,WAAA;EACA,eAAA;ARm+BJ;ACv8BI;EO3BA;IAEE,cAAA;IACA,kBAAA;ERo+BJ;AACF;AQl+BI;EACC,WAAA;ARo+BL;ACh9BI;EOrBA;IAGE,cAAA;IACA,aAAA;ERs+BJ;AACF;AQn+BI;EACC,cAAA;ARq+BL;ACz9BI;EOVC;IAEE,eAAA;ERq+BL;AACF;AC99BI;EOHA;IAEE,UAAA;IACA,qBAAA;ERm+BJ;AACF;AQj+BI;EACC,gBAAA;EACA,cAAA;ARm+BL;AQl+BK;EACC,mBAAA;EACA,sBAAA;EACA,sCAAA;ARo+BN;AQn+BM;EACC,sBAAA;EACA,sCAAA;ARq+BP;;ASniCA;EACC,kBAAA;ATsiCD;ASpiCC;EACC,SAAA;ATsiCF;;AU1iCA;EACC,WAAA;EACA,iBAAA;AV6iCD;AU3iCC;EACC,mBAAA;AV6iCF;AU1iCC;EACC,kBAAA;EACA,UAAA;EACA,eAAA;ET2JA,QAAA;EAGA,2BAAA;ADk5BF;ACzgCI;ES1CH;IAME,UAAA;EVijCD;AACF;AC9gCI;ESjCF;IAEE,UAAA;IACA,aAAA;EVijCF;AACF;AU9iCE;EACC,eAAA;EACC,iBAAA;AVgjCJ;ACxhCI;ES1BF;IAIG,eAAA;IACA,iBAAA;IACA,sBAAA;EVkjCH;AACF;AU7iCC;EACC,0BAAA;AV+iCF;AU7iCE;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACC,UAAA;EACA,+BAAA;EACA,WAAA;EACA,0BAAA;EACA,oBAAA;AV+iCJ;AU9iCI;EACC,UAAA;EACA,UAAA;AVgjCL;AU5iCE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AV8iCH;AU1iCC;EACC,YAAA;AV4iCF;AU1iCE;EACC,gBAAA;EACA,YAAA;AV4iCH;AU1iCG;EACC,gBAAA;EACA,YAAA;AV4iCJ;;AWjnCC;EACC,eAAA;EACA,gBAAA;EACA,WAAA;AXonCF;AWlnCE;EACC,WAAA;AXonCH;;AY5nCA;EACC,kBAAA;EACC,gBAAA;EAEA,YAAA;EACA,2BAAA;EACA,mCAAA;EACA,6BAAA;EACA,UAAA;EACA,qCAAA;AZ8nCF;AY5nCE;EXmMD,eAAA;AD47BD;AY3nCM;EXqKL,oBAAA;EACC,mCAAA;ADy9BF;ACx9BC;EACC;IAAK,mBAAA;ED29BL;EC19BA;IAAM,qBAAA;ED69BN;EC59BA;IAAM,qBAAA;ED+9BN;EC99BA;IAAM,qBAAA;EDi+BN;ECh+BA;IAAO,mBAAA;EDm+BP;AACF;AY1oCE;EACE,WAAA;EACA,UAAA;EACA,uBAAA;AZ4oCJ;AYzoCE;EACE,cAAA;AZ2oCJ;ACrnCI;EWvBF;IAGI,qBAAA;EZ6oCJ;AACF;;Aa5qCA;EACC,gBAAA;Ab+qCD;Aa7qCE;EACC,YAAA;Ab+qCH;Aa5qCC;EACC,eAAA;EACA,sBAAA;EACA,gBAAA;Ab8qCF;Aa5qCE;EACC,6CAAA;Ab8qCH;ACzoCI;EYtCF;IAIE,qCAAA;Eb+qCF;AACF;Aa9qCG;EACC,kBAAA;EACA,UAAA;AbgrCJ;AClpCI;EYhCD;IAIE,UAAA;EbkrCH;AACF;AahrCI;EAEC,eAAA;EZmLJ,eAAA;EYjLI,gBAAA;AbirCL;AC5pCI;EYzBA;IAME,eAAA;EbmrCJ;AACF;AalrCK;EARD;IASE,eAAA;IACA,iBAAA;EbqrCJ;AACF;AalrCM;EZ6IL,oBAAA;EACC,mCAAA;ADwiCF;ACviCC;EACC;IAAK,mBAAA;ED0iCL;ECziCA;IAAM,qBAAA;ED4iCN;EC3iCA;IAAM,qBAAA;ED8iCN;EC7iCA;IAAM,qBAAA;EDgjCN;EC/iCA;IAAO,mBAAA;EDkjCP;AACF;AalsCK;EACC,cAAA;EACA,WAAA;AbosCN;AChsCI;EYNC;IAIE,WAAA;IACA,qBAAA;EbssCL;AACF;AajsCG;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;AbmsCH;AalsCG;EACC,kBAAA;EACA,WAAA;EACA,6FAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AbosCJ;AajsCG;EACC,kBAAA;EACA,WAAA;EACA,2FAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;AbmsCJ;AChuCI;EYsBD;IAUE,YAAA;EbosCH;AACF;AajsCG;EACC,kBAAA;EACA,sBAAA;EACA,aAAA;AbmsCJ;AC1uCI;EYoCD;IAKE,aAAA;EbqsCH;AACF;AansCI;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,kBAAA;EACA,8BAAA;EACA,UAAA;AbqsCL;Aa/rCE;EACC,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AbisCH;AChwCI;EYyDF;IAQE,aAAA;IACA,eAAA;IACA,iBAAA;EbmsCF;AACF;AalsCG;EACC,cZrHI;EYsHJ,gBAAA;EACA,cAAA;AbosCJ;;Ac9zCA;EACE,aAAA;Adi0CF;;Ac9zCA;EACC,WAAA;Adi0CD;Ac/zCC;EACC,kBAAA;EACA,cAAA;EACA,gBAAA;Adi0CF;Ac5zCG;EACC,WAAA;Ad8zCJ;Ac1zCG;EACC,iBAAA;Ad4zCJ;Ac1zCG;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;Ad4zCJ;AczzCI;EACC,cb7BG;Ea8BH,kBAAA;Ad2zCL;AcxzCG;EACC,aAAA;Ad0zCJ;AC7yCI;EadD;IAGE,UAAA;Ed4zCH;AACF;Ac1zCG;EACC,mBbxCI;EayCJ,sBAAA;EACA,sBAAA;Ad4zCJ;Ac3zCI;EACC,sBAAA;EACA,gBAAA;EACA,qCAAA;Ad6zCL;AcvzCC;EACC,4BAAA;AdyzCF;AcxzCE;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;Ad0zCH;AcvzCE;EACC,eAAA;EACA,mBAAA;EACA,iBAAA;AdyzCH;ActzCE;EACC,cAAA;EACA,0BAAA;EACA,iBAAA;AdwzCH;AcrzCE;EACC,SAAA;AduzCH;AcpzCE;EACC,cAAA;AdszCH;AcnzCE;EACC,iBAAA;AdqzCH;AclzCE;EACC,SAAA;AdozCH;Ac7yCI;EACC,aAAA;Ad+yCL;AczyCC;EACC,YAAA;EACA,iBAAA;Ad2yCF;Ac1yCE;EACC,iBAAA;Ad4yCH;ACp2CI;EauDF;IAGE,iBAAA;Ed8yCF;AACF;AcvyCI;EACC,cAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EA0CA,qBAAA;EACA,sBAAA;AdgwCL;ACv3CI;EawEA;IAOE,eAAA;IACA,iBAAA;Ed4yCJ;AACF;Ac3yCK;EACC,aAAA;Ad6yCN;Ac3yCK;EACC,cAAA;EACA,gBAAA;EACA,eAAA;Ad6yCN;ACr4CI;EaqFC;IAME,eAAA;IACA,iBAAA;IACA,mBAAA;Ed8yCL;AACF;Ac5yCK;EACC,gBAAA;EACA,mBAAA;Ad8yCN;ACh5CI;EagGC;IAIE,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;EdgzCL;AACF;Ac9yCK;EACC,kBAAA;EACA,qBAAA;EACA,mBAAA;AdgzCN;AC75CI;Ea0GC;IAKE,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;EdkzCL;AACF;ACt6CI;EawEA;IAiDE,mBAAA;EdizCJ;AACF;AchzCK;EACC,cAAA;EACA,gBAAA;AdkzCN;AC/6CI;Ea2HC;IAKE,eAAA;IACA,iBAAA;EdmzCL;AACF;AcjzCM;EACC,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,yDAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,+FAAA;AdmzCP;AC37CI;Ea8HE;IAYE,iBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EdqzCN;AACF;Ac/yCI;EACC,cAAA;AdizCL;Ac/yCK;EACC,cAAA;EACA,eAAA;EACA,YAAA;AdizCN;Ac5yCI;EACC,6BAAA;Ad8yCL;Ac5yCI;EACC,kBAAA;EACA,sBAAA;Ad8yCL;Ac7yCK;EACC,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;Ad+yCN;AC19CI;EaqKC;IAQE,iBAAA;IACA,eAAA;IACA,iBAAA;EdizCL;EchzCK;IACC,gBAAA;EdkzCN;AACF;AchzCM;EACC,cbpOC;EaqOD,gBAAA;EACA,cAAA;AdkzCP;Ac1yCC;EACC,kBAAA;EACA,YAAA;Ad4yCF;Ac3yCE;EACC,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;Ad6yCH;AcxyCE;EACC,WAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,0EAAA;EACA,oBAAA;Ad0yCH;ActyCC;EACC,kBAAA;EACA,WAAA;AdwyCF;AcryCG;EACC,WAAA;AduyCJ;AcryCG;EACK,WAAA;AduyCR;AcpyCM;EACC,kBAAA;EAEA,qBAAA;AdqyCP;AcpyCO;EACC,yBb3RA;Ea4RA,wBAAA;AdsyCR;AcryCQ;EACC,uBAAA;AduyCT;AcnyCM;EACC,OAAA;AdqyCP;AcnyCM;EACC,QAAA;AdqyCP;AC5hDI;Ea2PF;IAEE,iBAAA;EdmyCF;AACF;ACzgDI;EawOA;IAEG,YAAA;EdmyCL;EclyCK;IACC,YAAA;EdoyCN;AACF;AchyCK;EACC,cAAA;EACA,gBAAA;AdkyCN;AchyCM;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,yDAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,+FAAA;AdkyCN;ACzjDI;Ea6QE;IAYC,iBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EdoyCL;AACF;AchyCG;EACC,kBAAA;EACA,gBAAA;AdkyCJ;ACrkDI;EaiSD;IAIE,kBAAA;IbjLH,QAAA;IAGA,2BAAA;IagLG,iBAAA;EduyCH;AACF;AcryCI;EACC,gBAAA;AduyCL;ACllDI;Ea0SA;IAGE,gBAAA;EdyyCJ;AACF;AcpyCE;EACC,kBAAA;AdsyCH;AcryCG;EACC,aAAA;AduyCJ;AcpyCG;EACC,UAAA;AdsyCJ;AclyCE;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AdoyCH;AclyCG;EACC,YAAA;EACA,YAAA;EACA,iBAAA;AdoyCJ;AchyCE;EACC,aAAA;AdkyCH;Ac/xCE;EACC,iBAAA;AdiyCH;AClnDI;EagVF;IAGE,SAAA;IACA,cAAA;IACA,UAAA;EdmyCF;AACF;Ac/xCE;EACC,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;AdiyCH;Ac7xCG;EACC,WAAA;Ad+xCJ;Ac5xCE;EACC,kBAAA;EACA,YAAA;EACA,UAAA;Ad8xCH;Ac1xCE;EACC,eAAA;EACA,YAAA;Ad4xCH;;Ae7rDA;EACC,aAAA;AfgsDD;AC/oDI;EclDJ;IAIE,oBAAA;EfisDA;AACF;Ae/rDC;EACC,mBAAA;AfisDF;Ae/rDC;EACC,kBAAA;EACA,cAAA;AfisDF;AC3pDI;EcxCH;IAIE,aAAA;EfmsDD;AACF;AejsDC;EACC,kBAAA;AfmsDF;AejsDG;EACC,UAAA;AfmsDJ;AehsDE;EACC,aAAA;EACA,oBAAA;AfksDH;Ae9rDE;EACC,aAAA;AfgsDH;Ae9rDE;EACC,kBAAA;AfgsDH;AChrDI;EcjBF;IAGE,kBAAA;IACA,kBAAA;EfksDF;AACF;Ae9rDC;EACC,iBAAA;AfgsDF;Ae/rDE;EACC,YAAA;AfisDH;AehsDG;EACC,8BAAA;EACA,WAAA;EACA,WAAA;AfksDJ;AehsDI;EACC,iBAAA;AfksDL;Ae7rDC;EACC,wCAAA;EAKA,iBAAA;EACA,YAAA;Af2rDF;AC/sDI;EcaH;IAGE,4BAAA;IACA,4BAAA;EfmsDD;AACF;AehsDE;EACC,gBAAA;AfksDH;AehsDE;EACC,cAAA;EACA,aAAA;AfksDH;AejsDG;EACC,QAAA;AfmsDJ;AejsDG;EACC,QAAA;AfmsDJ;AehsDE;EACC,qBAAA;EACA,iBAAA;EACA,kBAAA;AfksDH;ACjuDI;Ec4BF;IAKE,UAAA;IACA,iBAAA;IACA,oBAAA;IACA,mBAAA;EfosDF;AACF;AelsDE;EACC,qBAAA;EACA,cAAA;AfosDH;AC7uDI;EcuCF;IAIE,UAAA;EfssDF;AACF;AC1tDI;EceF;IAOE,UAAA;IACA,kBAAA;EfwsDF;AACF;;AgBtyDA;EACC,iBAAA;EACA,WAAA;EACA,sBAAA;AhByyDD;AgBvyDC;EACC,kBAAA;EfmKA,SAAA;EAGA,2BAAA;EepKA,kBAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;AhB4yDJ;AgB1yDI;EACC,kBAAA;AhB4yDL;AgBxyDC;EACC,WAAA;AhB0yDF;AC/wDI;Ee5BH;IAGE,UAAA;EhB4yDD;AACF;AgBzyDC;EAIC,aAAA;AhBwyDF;ACvxDI;EerBH;IAEE,UAAA;EhB8yDD;AACF;AgB1yDC;EACC,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AhB4yDF;AgB1yDE;EACC,WAAA;AhB4yDH;ACryDI;EeRF;IAGE,UAAA;EhB8yDF;AACF;AC1yDI;EedH;IAcE,cAAA;EhB8yDD;AACF;AC/yDI;EedH;IAkBE,YAAA;EhB+yDD;AACF;AgB7yDE;EASC,WAAA;AhBuyDH;AC7zDI;EeaF;IAEE,eAAA;IACA,iBAAA;EhBkzDF;AACF;AC7zDI;EeOF;IAME,gBAAA;IACA,kBAAA;EhBozDF;AACF;AgBhzDE;EACC,WAAA;EACA,qBAAA;EACA,UAAA;AhBkzDH;AgBjzDG;EACC,0BAAA;EACA,gBAAA;AhBmzDJ;AgB/yDE;EACC,eAAA;EACA,gBAAA;AhBizDH;ACh1DI;Ee6BF;IAKE,mBAAA;IACA,gBAAA;IACA,kBAAA;EhBkzDF;AACF;;AiBz4DA;EACC,yBAAA;AjB44DD;AiB14DC;EACC,wBAAA;EACA,uBAAA;EACA,iCAAA;AjB44DF;AiB14DC;EACC,aAAA;AjB44DF;AiB14DC;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AjB44DF;AC12DI;EgBjCF;IAEE,WAAA;IACA,YAAA;EjB64DF;AACF;ACh3DI;EgB3BF;IAEE,UAAA;IACA,YAAA;IACA,qBAAA;EjB64DF;AACF;AiB34DE;EACC,4BAAA;EACA,cAAA;EACA,UAAA;AjB64DH;AC53DI;EgBpBF;IAKE,yBAAA;EjB+4DF;AACF;AiB94DG;EACC,YAAA;EACA,aAAA;AjBg5DJ;AiB/4DI;EACC,qBAAA;EACA,UAAA;AjBi5DL;ACz4DI;EgBVA;IAIE,UAAA;EjBm5DJ;AACF;AiBj5DI;EACC,iBAAA;AjBm5DL;ACj5DI;EgBHA;IAGE,gBAAA;IACA,UAAA;IACA,qBAAA;EjBq5DJ;AACF;ACx5DI;EgBKA;IAEE,gBAAA;IACA,UAAA;IACA,qBAAA;EjBq5DJ;AACF;AiBl5DG;EACC,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;AjBo5DJ;AiBj5DG;EACC,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AjBm5DJ;AiB/4DE;EACC,kBAAA;EACA,iBAAA;EACA,YAAA;AjBi5DH;AiB94DC;EACC,kBAAA;AjBg5DF;AiB/4DE;EACC,kBAAA;EACA,wBAAA;EACA,yBAAA;EACA,UAAA;AjBi5DH;AiBh5DG;EACC,uBAAA;AjBk5DJ;AiB94DG;EACC,yBhB9FI;EgB+FJ,WAAA;AjBg5DJ;AiB74DE;EACC,kBAAA;EACA,YAAA;EACE,UAAA;AjB+4DL;ACr8DI;EgBmDF;IAKI,YAAA;IACF,UAAA;EjBi5DF;AACF;AiBh5DG;EACC,WAAA;AjBk5DJ;AiBj5DI;EACC,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AjBm5DL;AiBj5DI;EACC,eAAA;AjBm5DL;AiBh5DG;EACC,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BhB5HI;EgB6HJ,8BAAA;EACA,WAAA;AjBk5DJ;ACv+DI;EgB6ED;IAUE,yBhBhIG;IgBiIH,WAAA;EjBo5DH;AACF;AiBj5DE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;AjBm5DH;;AkB9hEE;EACC,aAAA;EACA,yBjBEI;EiBDJ,aAAA;EAqCC,kBAAA;EACA,yBAAA;AlB6/DJ;AkBliEG,gHACC,gCAAA,EACC,gCAAA;EACA,aAAA;EACA,kBAAA,EAAA,uBAAA;EACA,WAAA;AlBoiEL;AkBniEI;EACC,kBAAA,EAAA,gBAAA;AlBqiEL;ACtgEI;EiBhCA;IAGE,sBAAA;ElBuiEJ;AACF;ACn/DI;EiBxDA;IAME,WAAA;ElByiEJ;AACF;AkBtiEK;EACG,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mBjBtBD;EiBuBC,oBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,iCAAA;AlBwiER;AkBriEQ;EACE,UAAA;AlBuiEV;AkBhiEI;EACE,gBAAA;EACA,WAAA;AlBkiEN;AkBhiEG;EACC,aAAA;AlBkiEJ;AkBhiEK;EACC,YAAA;EACA,uBAAA;AlBkiEN;AkB/hEI;EACC,kBAAA;AlBiiEL;AkB3hEC;EACC,kBAAA;EjB8ID,eAAA;EiB5IC,mBAAA;AlB6hEF;AkB5hEE;EAIC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;AlB2hEH;AkBliEG;EACC,8BAAA;AlBoiEJ;AkB7hEG;EACC,eAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AlB+hEJ;AkB9hEI;EACC,WAAA;AlBgiEL;AkB/hEK;EACC,sBAAA;AlBiiEN;AkBvhEI;EACC,UAAA;AlByhEL;;AmBxnEA;EACC,aAAA;AnB2nED;AmBznEC;EACC,eAAA;EACA,gBAAA;AnB2nEF;AmBznEE;EACC,WAAA;EACA,aAAA;AnB2nEH;AChkEI;EkB7DF;IAIE,UAAA;EnB6nEF;AACF;ACrkEI;EkBpDH;IAEE,eAAA;EnB2nED;AACF;AmB1nEE;EACC,UAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;AnB4nEH;ACjlEI;EkBhDF;IAQE,gBAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;EnB6nEF;AACF;ACnlEI;EkBtDF;IAeE,gBAAA;IACA,WAAA;EnB8nEF;AACF;;AoBlqEC;EACC,eAAA;EACA,YAAA;EACA,kBAAA;ApBqqEF;AoBnqEE;EACC,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EnBoMF,eAAA;ADk+DD;AoBnqEG;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,UAAA;ApBqqEJ;AoBjqEI;EACC,UAAA;ApBmqEL;AoB/pEG;EACC,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,UAAA;EACA,iCAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;ApBiqEJ;AoB/pEI;EACC,kBAAA;EACA,UAAA;EACA,YAAA;ApBiqEL;AoB9pEI;EACC,iBAAA;EACA,aAAA;ApBgqEL;ACrqEI;EmBGA;IAKE,iBAAA;EpBiqEJ;AACF;AoB/pEK;EACC,iBAAA;EACA,gBAAA;ApBiqEN;AoB5pEG;EACC,WAAA;EACA,qBAAA;EACA,aAAA;ApB8pEJ;AC7qEI;EmB5CF;IA+DE,qBAAA;EpB8pEF;AACF;;AqBnuEC;EACC,kBAAA;EACA,UAAA;EpB0KA,SAAA;EAGA,2BAAA;EoB3KA,YAAA;EACA,eAAA;EACA,mBpBJM;EoBKN,qBAAA;EACA,YAAA;EACA,WAAA;EpBoMD,eAAA;ADsiED;AqBvuEE;EACC,gBAAA;EACA,WAAA;ArByuEH;AqBtuEC;EACC,6BAAA;ArBwuEF;AqBtuEE;EACC,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;ArBwuEH;AqBpuEE;EACC,gBAAA;ArBsuEH;AqBpuEE;EACC,YAAA;ArBsuEH;AqBnuEC;EACC,kBAAA;EpBuHA,SAAA;EACA,QAAA;EAGA,gCAAA;EoBzHA,WAAA;ArByuEF;AqBvuEC;EACC,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;ArByuEF;AqBvuEE;EACC,0BAAA;EACA,YAAA;ArByuEH;AqBvuEG;EACC,WAAA;ArByuEJ;;AqBnuEA;EACC,4BAAA;ArBsuED;AqBruEC;EACC,kBAAA;EACE,WAAA;EACA,OAAA;EACA,MAAA;EACA,yBpBjEI;EoBkEJ,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EAKA,qBAAA;ArBmuEJ;ACjwEI;EoBaH;IAcE,4CAAA;IACA,iBAAA;ErB0uED;AACF;AqBvuEI;EACC,cAAA;ArByuEL;AqBtuEI;EACC,+BAAA;EACA,mBAAA;ArBwuEL;AC9wEI;EoBoCA;IAIE,mBAAA;ErB0uEJ;AACF;AqBvuEI;EACC,+BAAA;EACA,kBAAA;ArByuEL;ACvxEI;EoB4CA;IAIE,mBAAA;ErB2uEJ;AACF;AqBxuEI;EACC,aAAA;ArB0uEL;AqBvuEC;EACC,UAAA;EACA,qBAAA;EACA,eAAA;ArByuEF;AClxEI;EoBsCH;IAME,qBAAA;ErB0uED;AACF;;AqBtuEA;EACC,kBAAA;EACA,qBAAA;ArByuED;AqBxuEC;EACC,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EpB8BD,6HAAA;AD6sED;;AqBtuEA;EACC,YAAA;ArByuED","sourcesContent":["@charset \"UTF-8\";\n@import url(\"https://use.typekit.net/zdq7lvi.css\");\n* {\n  margin: 0;\n  padding: 0;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n}\n\nhtml {\n  height: -webkit-fill-available;\n}\n\nbody {\n  background: #f8f8f2;\n  min-height: 100%;\n  /* mobile viewport bug fix */\n  min-height: -webkit-fill-available;\n}\n\nimg {\n  display: inherit;\n}\n\nh2 {\n  font-weight: unset;\n}\n\n.home, .page {\n  transition: 0.25s transform;\n}\n.home .section__copy, .home .top, .page .section__copy, .page .top {\n  text-align: left;\n  width: 95%;\n}\n.home .section__copy .headline, .home .top .headline, .page .section__copy .headline, .page .top .headline {\n  font-weight: unset;\n  display: inline;\n  font-size: 6vw;\n  line-height: 6.5vw;\n}\n.home .section__copy .headline:nth-child(2), .home .top .headline:nth-child(2), .page .section__copy .headline:nth-child(2), .page .top .headline:nth-child(2) {\n  color: #000;\n}\n.home .section__copy .headline:nth-child(2):before, .home .top .headline:nth-child(2):before, .page .section__copy .headline:nth-child(2):before, .page .top .headline:nth-child(2):before {\n  content: \"\\a\";\n  white-space: pre;\n}\n@media (min-width: 970px) {\n  .home .section__copy p, .home .top p, .page .section__copy p, .page .top p {\n    padding-left: 40px;\n    width: 40%;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.image-full-width img {\n  width: 100% !important;\n}\n\n.module-2-column {\n  margin: 20px 0;\n}\n.module-2-column img, .module-2-column .looping-video, .module-2-column .module-2-column__image {\n  width: 100%;\n  display: inherit;\n  margin-bottom: 20px;\n  object-fit: cover;\n}\n.module-2-column img:last-child, .module-2-column .looping-video:last-child, .module-2-column .module-2-column__image:last-child {\n  margin-bottom: 0;\n}\n@media (min-width: 970px) {\n  .module-2-column img, .module-2-column .looping-video, .module-2-column .module-2-column__image {\n    width: calc(50% - 10px) !important;\n    margin: 0 20px 0 0 !important;\n    display: inline-block;\n    vertical-align: top;\n  }\n  .module-2-column img:last-child, .module-2-column .looping-video:last-child, .module-2-column .module-2-column__image:last-child {\n    margin-right: 0 !important;\n  }\n}\n.module-2-column .looping-video {\n  width: 100%;\n  margin-top: 20px;\n}\n.module-2-column .looping-video:last-child {\n  margin-right: 0 !important;\n}\n.module-2-column .module-2-column__image img {\n  width: 100% !important;\n}\n.module-2-column .module-2-column__image .caption {\n  display: block !important;\n}\n\nbody {\n  font-family: degular, sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\np, .headline, .client-name {\n  margin: auto;\n}\n\n.button {\n  cursor: pointer;\n}\n\n.headline {\n  font-family: degular, sans-serif;\n  font-style: normal;\n  position: relative;\n  font-size: 4vh;\n  line-height: 4.5vh;\n  text-align: left;\n  margin-bottom: 1.5vh;\n}\n.headline b {\n  color: inherit;\n  font-weight: 700;\n  font-style: normal;\n  background-color: inherit;\n}\n@media (min-width: 970px) {\n  .headline {\n    font-size: 6vw;\n    line-height: 6.5vw;\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\n\n.caption {\n  font-size: 16px;\n  margin: 10px !important;\n  width: unset !important;\n}\n@media (min-width: 970px) {\n  .caption {\n    font-size: 21px;\n    padding: 60px 7.5%;\n  }\n}\n\n.looping-video, .standard-video {\n  margin: 20px 0;\n}\n\nb {\n  display: inline-block;\n}\n\np {\n  position: relative;\n  z-index: 1;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  display: block;\n  margin-top: 20px;\n}\np.size-2 {\n  font-size: 18px !important;\n}\np:first-child {\n  margin-top: 0;\n}\np:empty {\n  display: none !important;\n}\n@media (min-width: 970px) {\n  p {\n    font-size: 24px;\n    line-height: 32px;\n    vertical-align: middle;\n  }\n}\n\n.background:empty {\n  display: none;\n}\n\n.hide {\n  display: none;\n}\n\n.expand-icon {\n  cursor: pointer;\n  filter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);\n  display: inline-block;\n  vertical-align: middle;\n  transform-origin: left;\n  display: none;\n  width: 6vh;\n  margin-top: 15px;\n}\n.expand-icon:hover {\n  animation: bubble 1s;\n  animation-timing-function: ease-out;\n}\n@keyframes bubble {\n  0% {\n    transform: scale(1);\n  }\n  30% {\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  70% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n@media (min-width: 970px) {\n  .expand-icon {\n    position: absolute;\n    bottom: 8px;\n    width: 5vw;\n    height: auto;\n    margin-left: 2.5vw;\n  }\n}\n\na {\n  position: relative;\n  text-decoration-color: #55FF9E;\n  text-underline-position: under;\n  padding: 5px;\n  text-indent: -5px;\n  color: #000;\n}\na.size-2 {\n  font-size: 18px !important;\n}\na:hover {\n  background-color: #55FF9E;\n}\na:hover:after {\n  display: none;\n}\na.image-link:hover {\n  background-color: unset;\n}\n\n.gradient-theme, .content__item.gradient-theme, .embed__item.gradient-theme {\n  color: #FFF;\n  background: linear-gradient(270deg, rgb(251, 98, 48) 0%, rgb(252, 91, 65) 40%, rgb(252, 120, 79) 60%, rgb(252, 169, 54) 100%);\n}\n.gradient-theme .headline, .content__item.gradient-theme .headline, .embed__item.gradient-theme .headline {\n  color: #FFF;\n}\n.gradient-theme .headline:nth-child(2), .content__item.gradient-theme .headline:nth-child(2), .embed__item.gradient-theme .headline:nth-child(2) {\n  color: #000;\n}\n.gradient-theme a, .content__item.gradient-theme a, .embed__item.gradient-theme a {\n  color: #55FF9E;\n}\n.gradient-theme .expand-icon, .content__item.gradient-theme .expand-icon, .embed__item.gradient-theme .expand-icon {\n  color: #FFF;\n}\n\n.dark-theme, .content__item.dark-theme, .embed__item.dark-theme {\n  color: #FFF;\n  background-color: #000;\n}\n.dark-theme .headline, .content__item.dark-theme .headline, .embed__item.dark-theme .headline {\n  color: #FFF;\n}\n.dark-theme .headline:nth-child(2), .content__item.dark-theme .headline:nth-child(2), .embed__item.dark-theme .headline:nth-child(2) {\n  color: #FFF;\n}\n.dark-theme a, .content__item.dark-theme a, .embed__item.dark-theme a {\n  color: #55FF9E;\n}\n.dark-theme .expand-icon, .content__item.dark-theme .expand-icon, .embed__item.dark-theme .expand-icon {\n  color: #FFF;\n}\n\n.light-theme, .content__item.light-theme, .embed__item.light-theme {\n  color: #000;\n  background-color: #F8F8F3;\n}\n.light-theme a, .content__item.light-theme a, .embed__item.light-theme a {\n  color: #000;\n}\n.light-theme .headline, .content__item.light-theme .headline, .embed__item.light-theme .headline {\n  color: #FF3B00;\n}\n.light-theme .expand-icon, .content__item.light-theme .expand-icon, .embed__item.light-theme .expand-icon {\n  color: #000;\n}\n\n@keyframes bounce {\n  0% {\n    margin-top: 0;\n  }\n  30% {\n    margin-top: -40px;\n  }\n  50% {\n    margin-top: -15px;\n  }\n  100% {\n    margin: 0;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeOff {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes growRight {\n  0% {\n    width: 0;\n  }\n  100% {\n    width: 100%;\n  }\n}\n.app {\n  position: absolute;\n  width: 100%;\n}\n.app.home {\n  height: 100%;\n}\n.app:after {\n  content: \"\";\n  background: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.2));\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  height: 100px;\n  z-index: 3;\n  pointer-events: none;\n}\n.app.nav-expanded .home, .app.nav-expanded .page {\n  transform: translateX(-300px);\n}\n@media (min-width: 970px) {\n  .app.nav-expanded .home, .app.nav-expanded .page {\n    transform: translateX(-500px);\n  }\n}\n\n.nav {\n  position: fixed;\n  width: 100vw;\n  top: 0;\n  left: 0;\n  z-index: 4;\n}\n.nav.orange .nav__logo {\n  filter: unset;\n}\n.nav.orange .nav__menu .nav__menu__button.close .line {\n  background-color: #FFF;\n}\n.nav.orange .nav__menu .nav__menu__button .line {\n  background-color: #FF3B00;\n}\n.nav a {\n  color: unset;\n  text-decoration: none;\n}\n.nav a:hover {\n  background: none;\n}\n.nav__logo {\n  position: absolute;\n  width: 65px;\n  transition: 0.5s all ease-out;\n  filter: brightness(0) invert(1);\n  user-select: none;\n  top: 15px;\n  left: 15px;\n}\n@media (min-width: 1300px) {\n  .nav__logo {\n    width: 75px;\n  }\n}\n.nav__logo.hidden {\n  transform: translateY(-300px);\n}\n.nav__logo img {\n  width: 100%;\n}\n.nav__menu {\n  font-size: 24px;\n}\n@media (min-width: 970px) {\n  .nav__menu {\n    font-size: 30px;\n  }\n}\n.nav__menu__expanded {\n  position: fixed;\n  transition: 0.25s transform;\n  top: 0;\n  background: linear-gradient(120deg, rgb(251, 98, 48) 0%, rgb(252, 91, 65) 40%, rgb(252, 120, 79) 60%, rgb(252, 169, 54) 100%);\n  padding: 4vh 20px;\n  transform: translateX(100vw);\n  width: 300px;\n  height: 100vh;\n}\n@media (min-width: 970px) {\n  .nav__menu__expanded {\n    width: 500px;\n  }\n}\n.nav__menu__expanded.active {\n  transform: translateX(calc(100vw - 300px));\n}\n@media (min-width: 970px) {\n  .nav__menu__expanded.active {\n    transform: translateX(calc(100vw - 500px));\n  }\n}\n.nav__menu__expanded__list {\n  color: #FFF;\n  position: relative;\n  list-style: none;\n  text-align: center;\n}\n.nav__menu__expanded__list.social {\n  transform: none;\n  top: unset;\n  margin-top: 10vh;\n}\n.nav__menu__expanded__list.social:before {\n  position: absolute;\n  left: 10%;\n  top: -5vh;\n  content: \"\";\n  width: 80%;\n  height: 20px;\n  border-top: solid 2px #FFF;\n}\n.nav__menu__expanded__list.global {\n  margin-top: 5vh;\n}\n.nav__menu__expanded__list.global li {\n  display: inline-block;\n  font-size: 14px;\n  margin: 0 10px;\n}\n.nav__menu__expanded__list.global li.global {\n  font-size: 24px;\n  display: block;\n  width: 50%;\n  margin: 20px auto;\n}\n@media (min-width: 970px) {\n  .nav__menu__expanded__list.global li.global {\n    font-size: 30px;\n    width: 40%;\n  }\n}\n.nav__menu__expanded__list.global li::after {\n  height: 1px;\n}\n@media (min-width: 970px) {\n  .nav__menu__expanded__list.global li {\n    font-size: 15px;\n    margin: 0 20px;\n  }\n}\n.nav__menu__expanded__list li {\n  position: relative;\n  display: table;\n  margin: 3vh auto;\n  cursor: pointer;\n}\n.nav__menu__expanded__list li:first-child {\n  margin-top: 0;\n}\n.nav__menu__expanded__list li:last-child {\n  margin-bottom: 0;\n}\n.nav__menu__expanded__list li:after {\n  transition: 0.3s all ease-in-out;\n  position: absolute;\n  bottom: -8px;\n  left: 0;\n  height: 2px;\n  background-color: #FFF;\n  content: \"\";\n  width: 0;\n}\n.nav__menu__expanded__list li:hover:after {\n  width: 100%;\n}\n.nav__menu__button {\n  position: relative;\n  width: 30px;\n  height: 15px;\n  float: right;\n  cursor: pointer;\n  z-index: 3;\n  user-select: none;\n  top: 15px;\n  right: 15px;\n}\n.nav__menu__button:hover .line:first-child {\n  transform: translateY(3px);\n}\n.nav__menu__button:hover .line:last-child {\n  transform: translateY(-3px);\n}\n.nav__menu__button.close .line {\n  background-color: #FFF;\n}\n.nav__menu__button.close .line:first-child {\n  top: 50%;\n  transform: rotate(45deg);\n}\n.nav__menu__button.close .line:last-child {\n  top: 50%;\n  transform: rotate(-45deg);\n}\n.nav__menu__button .line {\n  width: 100%;\n  height: 3px;\n  background-color: #FFF;\n  position: absolute;\n  transition: 0.2s ease-out all;\n}\n.nav__menu__button .line:nth-child(1) {\n  top: 0;\n  left: 0;\n}\n.nav__menu__button .line:nth-child(2) {\n  bottom: 0;\n  left: 0;\n}\n\n.footer {\n  position: absolute;\n  left: 0;\n  z-index: 3;\n  background-color: #FF3B00;\n  padding: 10px;\n  color: #FFF;\n  width: 100vw;\n  height: 70px;\n  box-shadow: inset 0px 25px 30px -13px rgba(0, 0, 0, 0.3);\n  font-size: 15px;\n  opacity: 0;\n  transition: 0.5s opacity ease-out;\n}\n.footer.loaded {\n  opacity: 1;\n}\n@media (min-width: 970px) {\n  .footer {\n    padding: 20px 40px;\n    height: unset;\n    height: 90px;\n    font-size: 24px;\n  }\n}\n.footer__column {\n  width: 50%;\n  display: inline-block;\n  height: 100%;\n  transition: 0.3s all ease-out;\n  margin-top: 10px;\n}\n@media (max-width: 969px) {\n  .footer__column {\n    margin-top: 0;\n  }\n}\n.footer__column.left, .footer__column.right {\n  white-space: nowrap;\n}\n.footer__column.left a, .footer__column.right a {\n  color: #FFF;\n  padding: 0;\n  text-decoration-color: #FFF;\n  text-decoration: none;\n}\n.footer__column.left a:hover, .footer__column.right a:hover {\n  background: unset;\n}\n.footer__column.left {\n  position: relative;\n  z-index: 3;\n  width: 60%;\n}\n@media (max-width: 969px) {\n  .footer__column.left {\n    width: 50%;\n  }\n}\n.footer__column.left .footer__email, .footer__column.left .terms-privacy {\n  display: block;\n  margin-bottom: 20px;\n}\n@media (min-width: 970px) {\n  .footer__column.left .footer__email, .footer__column.left .terms-privacy {\n    display: inline-block;\n    margin: 0;\n  }\n  .footer__column.left .footer__email:last-child, .footer__column.left .terms-privacy:last-child {\n    margin-bottom: unset;\n  }\n}\n.footer__column.left .footer__email {\n  margin-bottom: 0;\n  white-space: nowrap;\n}\n.footer__column.left .terms-privacy {\n  display: block;\n  margin-bottom: 0;\n}\n@media (max-width: 969px) {\n  .footer__column.left .terms-privacy {\n    line-height: 15px;\n  }\n}\n@media (min-width: 970px) {\n  .footer__column.left .terms-privacy {\n    margin-left: 2vw;\n    display: inline-block;\n  }\n}\n.footer__column.left .terms-privacy a {\n  color: #dbdbdb;\n  opacity: 0.5;\n}\n.footer__column.left .terms-privacy a:hover {\n  opacity: 1;\n  text-decoration: underline;\n}\n.footer__column.right {\n  text-align: right;\n  width: 40%;\n  left: 0;\n  top: 0;\n  height: 100%;\n  display: inline-block;\n}\n@media (min-width: 970px) {\n  .footer__column.right {\n    position: relative;\n  }\n}\n@media (max-width: 969px) {\n  .footer__column.right {\n    line-height: 15px;\n    width: 50%;\n    vertical-align: top;\n  }\n  .footer__column.right .social__link {\n    margin-right: 10px;\n  }\n}\n.footer__column.right .social__link {\n  cursor: pointer;\n  display: inline-block;\n}\n@media (min-width: 970px) {\n  .footer__column.right .social__link {\n    margin-left: 2.4vw;\n  }\n}\n.footer__column.right .social__link:hover {\n  text-decoration: underline;\n}\n\n:root {\n  --textIndent: 0;\n}\n\n@keyframes marquee {\n  0% {\n    text-indent: 0;\n  }\n  100% {\n    text-indent: var(--textIndent);\n  }\n}\n@keyframes marqueeDesktop {\n  0% {\n    text-indent: 0;\n  }\n  100% {\n    text-indent: var(--textIndent);\n  }\n}\n.banner {\n  background-color: #55FF9E;\n  color: #000;\n  white-space: nowrap;\n  text-transform: uppercase;\n  padding: 10px 0;\n  overflow-x: hidden;\n  animation: 8s marquee linear infinite;\n  font-size: 32px;\n  line-height: 50px;\n}\n@media (min-width: 1800px) {\n  .banner {\n    height: 100px;\n    animation: 8s marqueeDesktop linear infinite;\n    font-size: 80px;\n    line-height: 70px;\n  }\n}\n.banner span {\n  margin-left: 10px;\n}\n\n.content__item.active:before {\n  opacity: 1;\n}\n.content__item__section.description {\n  height: 100vh;\n}\n.content__item__section.description .section__copy {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n.content__item__section.description .section__copy.fade p {\n  mask-image: -webkit-gradient(linear, left 20%, left 70%, from(rgb(0, 0, 0)), to(rgba(0, 0, 0, 0)));\n  margin-bottom: 0;\n}\n@media (min-width: 970px) {\n  .content__item__section.description .section__copy.fade p {\n    mask-image: none;\n    margin-top: 40px;\n  }\n}\n.content__item__section.expanded .headline, .content__item__section.expanded p {\n  color: inherit !important;\n}\n.content__item__section.expanded p {\n  width: unset;\n  display: block;\n}\n.content__item__section.expanded .embed__item:last-child {\n  padding-bottom: 70px;\n}\n.content__item__section .section__background {\n  max-height: 100vh;\n}\n\n.content__item {\n  position: relative;\n  width: 100%;\n  margin-top: 0;\n  scroll-snap-align: start;\n}\n.content__item__section {\n  position: relative;\n}\n.content__item__section.description {\n  padding: 70px 0;\n}\n.content__item__section.description .section__copy {\n  padding: 0 7.5%;\n}\n.content__item__section .section__copy {\n  position: relative;\n  z-index: 2;\n}\n.content__item__section .section__background {\n  position: absolute;\n  top: 0;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  max-height: unset;\n}\n.content__item__section .section__background img, .content__item__section .section__background video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.carousel-container {\n  position: relative;\n  height: inherit;\n}\n.carousel-container.autoplay.speed-1 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 1s;\n}\n.carousel-container.autoplay.speed-2 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 2s;\n}\n.carousel-container.autoplay.speed-3 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 3s;\n}\n.carousel-container.autoplay.speed-4 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 4s;\n}\n.carousel-container.autoplay.speed-5 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 5s;\n}\n.carousel-container.autoplay.speed-6 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 6s;\n}\n.carousel-container.autoplay.speed-7 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 7s;\n}\n.carousel-container.autoplay.speed-8 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 8s;\n}\n.carousel-container.autoplay.speed-9 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 9s;\n}\n.carousel-container.autoplay.speed-10 .flickity-page-dots .dot.is-selected:before {\n  animation-duration: 10s;\n}\n.carousel-container.autoplay .flickity-page-dots .dot.is-selected:before {\n  animation: 3s growRight forwards linear;\n}\n.carousel-container .content__item {\n  height: 100%;\n}\n.carousel-container .carousel {\n  overflow: hidden;\n  height: 100%;\n  outline: none;\n}\n.carousel-container .carousel.hidden {\n  display: none;\n}\n.carousel-container .carousel::-webkit-scrollbar {\n  height: 0px;\n  width: 0px;\n  background: transparent;\n}\n.carousel-container .carousel__item {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  margin-top: 0;\n  display: inline-block;\n  opacity: 0;\n  transition: opacity 1s ease-out;\n}\n.carousel-container .carousel__item.loaded {\n  opacity: 1;\n}\n.carousel-container .carousel__item a {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  text-indent: unset;\n  color: unset;\n}\n.carousel-container .carousel__item a:hover {\n  background: unset;\n}\n.carousel-container .carousel__item__title {\n  position: absolute;\n  z-index: 2;\n  font-size: 21px;\n  bottom: 40px;\n  left: 7%;\n  cursor: pointer;\n}\n.carousel-container .carousel__item__title a {\n  position: relative;\n}\n.carousel-container .carousel__item__title:hover .main {\n  background-color: transparent;\n  text-decoration: underline;\n  text-underline-position: under;\n  text-decoration-color: #55FF9E;\n  color: #FFF;\n}\n@media (min-width: 970px) {\n  .carousel-container .carousel__item__title {\n    left: 3%;\n  }\n}\n.carousel-container .carousel__item__title .main {\n  background-color: #55FF9E;\n  padding: 7px 7px 5px 7px;\n  color: #000;\n  margin-right: 10px;\n  line-height: 30px;\n}\n.carousel-container .carousel__item__title .subtitle {\n  position: relative;\n  top: 1px;\n  background-color: none !important;\n  color: #FFF;\n  vertical-align: bottom;\n  line-height: 40px;\n}\n.carousel-container .carousel__item__title .subtitle a {\n  text-decoration: none;\n}\n@media (max-width: 969px) {\n  .carousel-container .carousel__item__title .subtitle {\n    display: block;\n    margin-top: 20px;\n    line-height: 30px;\n  }\n}\n.carousel-container .carousel__item__background {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.carousel-container .carousel__item__background video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.carousel-container .carousel__item__background img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.carousel-container .flickity-page-dots {\n  position: relative;\n  z-index: 3;\n  display: none;\n  bottom: 15px;\n}\n@media (min-width: 1300px) {\n  .carousel-container .flickity-page-dots {\n    bottom: 20px;\n  }\n}\n.carousel-container .flickity-page-dots .dot {\n  opacity: 1;\n  position: relative;\n  border-radius: 12px;\n  margin: 0 0.2vw;\n  background: rgba(255, 255, 255, 0.3);\n  height: 0.5vw;\n  min-height: 5px;\n}\n.carousel-container .flickity-page-dots .dot:first-child {\n  margin-left: 0;\n}\n.carousel-container .flickity-page-dots .dot:last-child {\n  margin-right: 0;\n}\n.carousel-container .flickity-page-dots .dot.is-selected {\n  background: rgba(255, 255, 255, 0.3);\n}\n.carousel-container .flickity-page-dots .dot.is-selected:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.6);\n  pointer-events: none;\n}\n\n.hero {\n  position: relative;\n  width: 100%;\n  min-height: 100vh;\n  background-size: cover;\n  background-position: center center;\n}\n.hero.offices p {\n  margin: 80px 0 0 0.5vw;\n}\n.hero.offices .expand-icon {\n  display: none;\n}\n.hero__content {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  font-size: initial;\n  color: #FFF;\n  width: 100%;\n  padding: 0 7.5%;\n}\n@media (min-width: 970px) {\n  .hero__content .headline {\n    font-size: 6vw;\n    line-height: 6.5vw;\n  }\n}\n.hero__content .headline, .hero__content p {\n  color: #FFF;\n}\n@media (min-width: 970px) {\n  .hero__content .headline, .hero__content p {\n    display: block;\n    margin: unset;\n  }\n}\n.hero__content .headline {\n  display: block;\n}\n@media (min-width: 970px) {\n  .hero__content .headline:nth-child(2) {\n    display: inline;\n  }\n}\n@media (min-width: 970px) {\n  .hero__content .copy {\n    width: 95%;\n    display: inline-block;\n  }\n}\n.hero__content p {\n  margin-top: 20px;\n  display: block;\n}\n.hero__content p a {\n  margin-bottom: 10px;\n  color: #FFF !important;\n  text-decoration-color: #FFF !important;\n}\n.hero__content p a:hover {\n  color: #000 !important;\n  text-decoration-color: #000 !important;\n}\n\n.text-block {\n  padding: 60px 7.5%;\n}\n.text-block .headline {\n  margin: 0;\n}\n\n.custom-slideshow {\n  color: #FFF;\n  min-height: 100vh;\n}\n.custom-slideshow .headline {\n  margin-bottom: 20px;\n}\n.custom-slideshow__content {\n  position: absolute;\n  z-index: 2;\n  padding: 0 7.5%;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n@media (min-width: 970px) {\n  .custom-slideshow__content {\n    width: 80%;\n  }\n}\n@media (min-width: 970px) {\n  .custom-slideshow__content p {\n    width: 90%;\n    margin: unset;\n  }\n}\n.custom-slideshow__content span {\n  font-size: 16px;\n  line-height: 24px;\n}\n@media (min-width: 970px) {\n  .custom-slideshow__content span {\n    font-size: 24px;\n    line-height: 32px;\n    vertical-align: middle;\n  }\n}\n.custom-slideshow .flickity-slider {\n  transform: none !important;\n}\n.custom-slideshow .flickity-slider .slider__item {\n  width: 100vw;\n  height: 100vh;\n  left: 0 !important;\n  opacity: 0;\n  transition: opacity 1s ease-out;\n  z-index: -1;\n  transform: none !important;\n  pointer-events: none;\n}\n.custom-slideshow .flickity-slider .slider__item.is-selected {\n  opacity: 1;\n  z-index: 0;\n}\n.custom-slideshow .flickity-slider img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.custom-slideshow .flickity-page-dots {\n  bottom: 50px;\n}\n.custom-slideshow .flickity-page-dots .dot {\n  background: #FFF;\n  opacity: 0.3;\n}\n.custom-slideshow .flickity-page-dots .dot.is-selected {\n  background: #FFF;\n  opacity: 0.8;\n}\n\n.instagram-feed__banner {\n  padding: 80px 0;\n  max-width: 670px;\n  width: 100%;\n}\n.instagram-feed__banner img {\n  width: 100%;\n}\n\n.page.home {\n  position: relative;\n  overflow: scroll;\n  height: 100%;\n  scroll-snap-type: mandatory;\n  scroll-snap-points-y: repeat(100vh);\n  scroll-snap-type: y mandatory;\n  opacity: 0;\n  animation: 1s fadeIn ease-in forwards;\n}\n.page.home .copy, .page.home .custom-slideshow .headline {\n  cursor: pointer;\n}\n.page.home .copy:hover .expand-icon, .page.home .custom-slideshow .headline:hover .expand-icon {\n  animation: bubble 1s;\n  animation-timing-function: ease-out;\n}\n@keyframes bubble {\n  0% {\n    transform: scale(1);\n  }\n  30% {\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  70% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.page.home::-webkit-scrollbar {\n  height: 0px;\n  width: 0px;\n  background: transparent;\n}\n.page.home .expand-icon {\n  display: block;\n}\n@media (min-width: 970px) {\n  .page.home .expand-icon {\n    display: inline-block;\n  }\n}\n\n.page.about {\n  padding-top: 5vw;\n}\n.page.about__section.top {\n  height: 95vh;\n}\n.page.about .expanded {\n  padding: 0 7.5%;\n  background-color: #000;\n  overflow: hidden;\n}\n.page.about .expanded .parallax {\n  height: calc(100vh * var(--imageNum) - 200px);\n}\n@media (min-width: 970px) {\n  .page.about .expanded .parallax {\n    height: calc(600px * var(--imageNum));\n  }\n}\n.page.about .expanded .parallax__copy {\n  position: relative;\n  z-index: 4;\n}\n@media (min-width: 970px) {\n  .page.about .expanded .parallax__copy {\n    width: 63%;\n  }\n}\n.page.about .expanded .parallax__copy .link {\n  font-size: 32px;\n  cursor: pointer;\n  margin-top: -2vh;\n}\n@media (min-width: 970px) {\n  .page.about .expanded .parallax__copy .link {\n    font-size: 40px;\n  }\n}\n@media (max-height: 600px) {\n  .page.about .expanded .parallax__copy .link {\n    font-size: 25px;\n    line-height: 32px;\n  }\n}\n.page.about .expanded .parallax__copy .link:hover .expand-icon {\n  animation: bubble 1s;\n  animation-timing-function: ease-out;\n}\n@keyframes bubble {\n  0% {\n    transform: scale(1);\n  }\n  30% {\n    transform: scale(1.3);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  70% {\n    transform: scale(1.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.page.about .expanded .parallax__copy .link .expand-icon {\n  display: block;\n  width: 30px;\n}\n@media (min-width: 970px) {\n  .page.about .expanded .parallax__copy .link .expand-icon {\n    width: 40px;\n    display: inline-block;\n  }\n}\n.page.about .expanded .parallax__images {\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  height: 100%;\n  margin: 0 0 0 -7.5%;\n  padding: 0;\n}\n.page.about .expanded .parallax__images:before {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(180deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 100%);\n  opacity: 0.75;\n  width: 100%;\n  height: 200px;\n  z-index: 3;\n}\n.page.about .expanded .parallax__images:after {\n  position: absolute;\n  content: \"\";\n  background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 20%, rgba(0, 0, 0, 0) 100%);\n  width: 100%;\n  height: 200px;\n  z-index: 3;\n  bottom: 0;\n}\n@media (min-width: 970px) {\n  .page.about .expanded .parallax__images:after {\n    bottom: 50px;\n  }\n}\n.page.about .expanded .parallax__images .parallax-image {\n  position: relative;\n  background-size: cover;\n  height: 100vh;\n}\n@media (min-width: 970px) {\n  .page.about .expanded .parallax__images .parallax-image {\n    height: 600px;\n  }\n}\n.page.about .expanded .parallax__images .parallax-image:before {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: 0;\n  position: absolute;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 0;\n}\n.page.about .expanded p {\n  position: relative;\n  z-index: 2;\n  font-weight: 400;\n  margin: 12vh 0;\n  font-size: 32px;\n  line-height: 40px;\n}\n@media (min-width: 970px) {\n  .page.about .expanded p {\n    margin: 7vw 0;\n    font-size: 40px;\n    line-height: 45px;\n  }\n}\n.page.about .expanded p b {\n  color: #55FF9E;\n  font-weight: 400;\n  display: block;\n}\n\n:root {\n  --imageNum: 0;\n}\n\n.page {\n  width: 100%;\n}\n.page .expanded__bottom {\n  position: relative;\n  display: block;\n  margin-top: 80px;\n}\n.page.culture .happenings img {\n  width: 100%;\n}\n.page.culture .hero.edi {\n  min-height: unset;\n}\n.page.culture .hero__content {\n  position: relative;\n  top: unset;\n  left: unset;\n  transform: unset;\n  padding: 80px 7.5%;\n}\n.page.culture .hero .headline b {\n  color: #55FF9E;\n  font-weight: unset;\n}\n.page.culture .hero p {\n  margin: 5vw 0;\n}\n@media (min-width: 970px) {\n  .page.culture .hero p {\n    width: 60%;\n  }\n}\n.page.culture .hero a {\n  background: #55FF9E;\n  color: #000 !important;\n  text-decoration: unset;\n}\n.page.culture .hero a:hover {\n  color: #FFF !important;\n  background: none;\n  text-decoration: underline !important;\n}\n.page.terms-privacy {\n  padding: 100px 10% 150px 10%;\n}\n.page.terms-privacy * {\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: unset;\n}\n.page.terms-privacy h1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  font-weight: bold;\n}\n.page.terms-privacy h2, .page.terms-privacy h3 {\n  margin: 10px 0;\n  text-decoration: underline;\n  font-weight: bold;\n}\n.page.terms-privacy p {\n  margin: 0;\n}\n.page.terms-privacy ul {\n  margin: 10px 0;\n}\n.page.terms-privacy li {\n  margin-left: 20px;\n}\n.page.terms-privacy .footer {\n  bottom: 0;\n}\n.page.list .content__item:nth-last-of-type(2) .expand-icon {\n  bottom: -35px;\n}\n.page.home {\n  height: 100%;\n  min-height: unset;\n}\n.page.home .footer {\n  margin-top: -70px;\n}\n@media (min-width: 970px) {\n  .page.home .footer {\n    margin-top: -90px;\n  }\n}\n.page.strategy-studio .content__item.strategy-studio .headline {\n  display: block;\n  color: #FFF;\n  font-size: 4vw;\n  line-height: 4.5vw;\n  transform: scale(0.8);\n  transform-origin: left;\n}\n@media (max-width: 969px) {\n  .page.strategy-studio .content__item.strategy-studio .headline {\n    font-size: 40px;\n    line-height: 45px;\n  }\n}\n.page.strategy-studio .content__item.strategy-studio .headline:before {\n  display: none;\n}\n.page.strategy-studio .content__item.strategy-studio .headline:first-child {\n  font-size: 6vw;\n  line-height: 5vw;\n  transform: none;\n}\n@media (max-width: 969px) {\n  .page.strategy-studio .content__item.strategy-studio .headline:first-child {\n    font-size: 60px;\n    line-height: 55px;\n    margin-bottom: 20px;\n  }\n}\n.page.strategy-studio .content__item.strategy-studio .headline:nth-child(n+3):nth-child(-n+7) {\n  line-height: 3vw;\n  white-space: nowrap;\n}\n@media (max-width: 969px) {\n  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(n+3):nth-child(-n+7) {\n    white-space: unset;\n    font-size: 30px;\n    line-height: 35px;\n    margin-bottom: 20px;\n  }\n}\n.page.strategy-studio .content__item.strategy-studio .headline:nth-child(2) {\n  margin-bottom: 3vw;\n  transform: scale(0.6);\n  white-space: nowrap;\n}\n@media (max-width: 969px) {\n  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(2) {\n    white-space: unset;\n    transform: scale(1);\n    font-size: 25px;\n    line-height: 30px;\n    margin-bottom: 50px;\n  }\n}\n@media (max-width: 969px) {\n  .page.strategy-studio .content__item.strategy-studio .headline {\n    transform: scale(1);\n  }\n}\n.page.strategy-studio .content__item.strategy-studio .headline:nth-child(8) {\n  display: block;\n  padding-top: 4vw;\n}\n@media (max-width: 969px) {\n  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(8) {\n    font-size: 30px;\n    line-height: 35px;\n  }\n}\n.page.strategy-studio .content__item.strategy-studio .headline:nth-child(8):after {\n  content: \"\";\n  position: absolute;\n  transform: rotate(90deg);\n  background-image: url(\"../images/arrow.svg\");\n  background-size: cover;\n  width: 30px;\n  height: 26px;\n  bottom: 5px;\n  margin-left: 10px;\n  filter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);\n}\n@media (min-width: 970px) {\n  .page.strategy-studio .content__item.strategy-studio .headline:nth-child(8):after {\n    margin-left: 20px;\n    width: 60px;\n    height: 52px;\n    bottom: 20px;\n  }\n}\n.page.strategy-studio .content__item.strategy-studio-contact .top {\n  padding-top: 0;\n}\n.page.strategy-studio .content__item.strategy-studio-contact .top p {\n  display: block;\n  padding-left: 0;\n  width: unset;\n}\n.page.strategy-studio .content__item__section.top {\n  padding: 140px 7.5% 80px 7.5%;\n}\n.page.strategy-studio .content__item__section.expanded {\n  padding: 80px 7.5%;\n  background-color: #000;\n}\n.page.strategy-studio .content__item__section.expanded p {\n  position: relative;\n  z-index: 2;\n  font-weight: 400;\n  margin: 0 0 12vh 0;\n  font-size: 32px;\n  line-height: 40px;\n}\n@media (min-width: 970px) {\n  .page.strategy-studio .content__item__section.expanded p {\n    margin: 0 0 7vw 0;\n    font-size: 40px;\n    line-height: 45px;\n  }\n  .page.strategy-studio .content__item__section.expanded p:last-child {\n    margin-bottom: 0;\n  }\n}\n.page.strategy-studio .content__item__section.expanded p b {\n  color: #55FF9E;\n  font-weight: 400;\n  display: block;\n}\n.page .embedded__media {\n  position: relative;\n  height: 100%;\n}\n.page .embedded__media__description {\n  position: absolute;\n  padding: 20px;\n  transition: 0.2s all ease-out;\n  opacity: 0;\n  pointer-events: none;\n  width: calc(100% - 20px);\n  height: 100%;\n  white-space: pre-wrap;\n}\n.page.close-visible:before {\n  content: \"\";\n  position: fixed;\n  z-index: 3;\n  height: 100px;\n  width: 100%;\n  bottom: 0;\n  background: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.2));\n  pointer-events: none;\n}\n.page__section {\n  position: relative;\n  width: 100%;\n}\n.page__section.expanded img {\n  width: 100%;\n}\n.page__section.expanded video {\n  width: 100%;\n}\n.page__section.expanded .back-btn, .page__section.expanded .more-btn {\n  position: absolute;\n  display: inline-block;\n}\n.page__section.expanded .back-btn a, .page__section.expanded .more-btn a {\n  background-color: #55FF9E;\n  padding: 7px 7px 5px 7px;\n}\n.page__section.expanded .back-btn a:hover, .page__section.expanded .more-btn a:hover {\n  background-color: unset;\n}\n.page__section.expanded .back-btn {\n  left: 0;\n}\n.page__section.expanded .more-btn {\n  right: 0;\n}\n@media (min-width: 970px) {\n  .page__section.top {\n    margin-top: 100px;\n  }\n}\n@media (min-width: 1800px) {\n  .page__section.top .headline br {\n    content: \" \";\n  }\n  .page__section.top .headline br:after {\n    content: \" \";\n  }\n}\n.page__section.top .headline:nth-child(3) {\n  display: block;\n  padding-top: 4vw;\n}\n.page__section.top .headline:nth-child(3):after {\n  content: \"\";\n  position: absolute;\n  transform: rotate(90deg);\n  background-image: url(\"../images/arrow.svg\");\n  background-size: cover;\n  width: 30px;\n  height: 26px;\n  bottom: 5px;\n  margin-left: 10px;\n  filter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);\n}\n@media (min-width: 970px) {\n  .page__section.top .headline:nth-child(3):after {\n    margin-left: 20px;\n    width: 60px;\n    height: 52px;\n    bottom: 20px;\n  }\n}\n.page__section.top .copy {\n  padding: 70px 7.5%;\n  margin-top: 50px;\n}\n@media (min-width: 970px) {\n  .page__section.top .copy {\n    position: relative;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    margin-top: -50px;\n  }\n}\n.page__section.top .copy p {\n  margin-top: 20px;\n}\n@media (min-width: 970px) {\n  .page__section.top .copy p {\n    margin-top: 40px;\n  }\n}\n.page__section.embed {\n  padding: 70px 7.5%;\n}\n.page__section.embed:empty {\n  display: none;\n}\n.page__section.embed .copy {\n  padding: 0;\n}\n.page__section .section__background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.page__section .section__background img, .page__section .section__background video {\n  width: 100vw;\n  height: 100%;\n  object-fit: cover;\n}\n.page__section .content {\n  padding: 0 5%;\n}\n.page__section .client-name {\n  margin: 20px auto;\n}\n@media (min-width: 970px) {\n  .page__section .client-name {\n    margin: 0;\n    display: block;\n    width: 50%;\n  }\n}\n.page__section.top {\n  display: inline-block;\n  transition: 0.3s all ease-out;\n  padding-top: 100px;\n  height: 100vh;\n}\n.page__section .content img {\n  width: 100%;\n}\n.page__section .copy, .page__section .content {\n  position: relative;\n  margin: auto;\n  z-index: 2;\n}\n.page .close {\n  position: fixed;\n  bottom: 30px;\n}\n\n.page.work {\n  height: unset;\n}\n@media (min-width: 970px) {\n  .page.work {\n    padding-bottom: 40px;\n  }\n}\n.page.work .hero {\n  margin-bottom: 10px;\n}\n.page.work .footer {\n  position: absolute;\n  bottom: -130px;\n}\n@media (min-width: 970px) {\n  .page.work .footer {\n    bottom: -60px;\n  }\n}\n.page.work .content__item {\n  padding: 10px 20px;\n}\n.page.work .content__item:hover .section__background .embedded__media .embedded__media__description {\n  opacity: 1;\n}\n.page.work .content__item .description {\n  height: unset;\n  padding-bottom: 40vw;\n}\n.page.work .page__section.top {\n  display: none;\n}\n.page.work .page__section .client-name {\n  margin-bottom: 5px;\n}\n@media (min-width: 970px) {\n  .page.work .page__section .client-name {\n    padding-left: 40px;\n    margin-bottom: 0px;\n  }\n}\n.page.work .section__background {\n  min-height: unset;\n}\n.page.work .section__background .embedded__media {\n  height: 100%;\n}\n.page.work .section__background .embedded__media .embedded__media__description {\n  background: rgba(0, 0, 0, 0.4);\n  color: #FFF;\n  width: 100%;\n}\n.page.work .section__background .embedded__media .embedded__media__description .client {\n  font-weight: bold;\n}\n.page.work .expanded {\n  padding: 120px 20px 50px 20px !important;\n  max-width: 1800px;\n  margin: auto;\n}\n@media (max-width: 969px) {\n  .page.work .expanded {\n    padding-top: 80px !important;\n    padding-bottom: 0 !important;\n  }\n}\n.page.work .expanded p {\n  margin-top: 10px;\n}\n.page.work .expanded .embedded__media {\n  margin: 20px 0;\n  display: grid;\n}\n.page.work .expanded .embedded__media img {\n  order: 1;\n}\n.page.work .expanded .embedded__media .caption {\n  order: 2;\n}\n.page.work .expanded .headline {\n  display: inline-block;\n  margin-left: -2px;\n  margin-bottom: 0px;\n}\n@media (min-width: 970px) {\n  .page.work .expanded .headline {\n    width: 60%;\n    margin-left: -5px;\n    padding: 0 5% 0 40px;\n    vertical-align: top;\n  }\n}\n.page.work .expanded p {\n  display: inline-block;\n  margin: 20px 0;\n}\n@media (min-width: 970px) {\n  .page.work .expanded p {\n    width: 35%;\n  }\n}\n@media (min-width: 1800px) {\n  .page.work .expanded p {\n    width: 40%;\n    padding-left: 20px;\n  }\n}\n\n.contact {\n  min-height: 100vh;\n  color: #FFF;\n  background-size: cover;\n}\n.contact__content {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  font-size: initial;\n  color: #FFF;\n  width: 100%;\n  padding: 13vh 7.5% 0 7.5%;\n}\n.contact__content .header-copy {\n  margin-bottom: 2vh;\n}\n.contact .headline {\n  width: 100%;\n}\n@media (min-width: 970px) {\n  .contact .headline {\n    width: 60%;\n  }\n}\n.contact p {\n  margin: unset;\n}\n@media (min-width: 970px) {\n  .contact p {\n    width: 70%;\n  }\n}\n.contact__column {\n  width: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: 2vh;\n}\n.contact__column.full-width {\n  width: 100%;\n}\n@media (min-width: 970px) {\n  .contact__column.full-width {\n    width: 40%;\n  }\n}\n@media (min-width: 970px) {\n  .contact__column {\n    margin: 40px 0;\n  }\n}\n@media (min-width: 970px) {\n  .contact__column {\n    width: 27.5%;\n  }\n}\n.contact__column p {\n  width: 100%;\n}\n@media (max-width: 969px) {\n  .contact__column p {\n    font-size: 15px;\n    line-height: 18px;\n  }\n}\n@media (min-width: 970px) {\n  .contact__column p {\n    font-size: 1.4vw;\n    line-height: 1.8vw;\n  }\n}\n.contact__column a {\n  color: #FFF;\n  text-decoration: none;\n  padding: 0;\n}\n.contact__column a:hover {\n  text-decoration: underline;\n  background: none;\n}\n.contact__column .column__title {\n  font-size: 15px;\n  font-weight: 700;\n}\n@media (min-width: 970px) {\n  .contact__column .column__title {\n    margin-bottom: 10px;\n    font-size: 1.4vw;\n    line-height: 1.8vw;\n  }\n}\n\n.page.news {\n  padding: 0 20px 20px 20px;\n}\n.page.news .hero {\n  height: 100vh !important;\n  width: 100vw !important;\n  margin: 0 0 40px -20px !important;\n}\n.page.news .expanded {\n  display: none;\n}\n.page.news .content__item {\n  width: 100%;\n  height: 70vw;\n  padding: 0 20px 20px 20px;\n  min-height: unset;\n  margin-bottom: 20px;\n}\n@media (min-width: 970px) {\n  .page.news .content__item.size-2 {\n    width: 100%;\n    height: 40vw;\n  }\n}\n@media (min-width: 970px) {\n  .page.news .content__item.size-1 {\n    width: 50%;\n    height: 50vw;\n    display: inline-block;\n  }\n}\n.page.news .content__item .copy {\n  font-family: \"PPNeueMachina\";\n  display: block;\n  padding: 0;\n}\n@media (min-width: 970px) {\n  .page.news .content__item .copy {\n    padding: 0 40px 20px 40px;\n  }\n}\n.page.news .content__item .copy p {\n  width: unset;\n  margin-top: 0;\n}\n.page.news .content__item .copy p:nth-child(1), .page.news .content__item .copy p:nth-child(2) {\n  display: inline-block;\n  width: 50%;\n}\n@media (min-width: 970px) {\n  .page.news .content__item .copy p:nth-child(1), .page.news .content__item .copy p:nth-child(2) {\n    width: 25%;\n  }\n}\n.page.news .content__item .copy p:nth-child(2) {\n  text-align: right;\n}\n@media (min-width: 970px) {\n  .page.news .content__item .copy p:nth-child(2) {\n    text-align: left;\n    width: 25%;\n    display: inline-block;\n  }\n}\n@media (min-width: 970px) {\n  .page.news .content__item .copy p:nth-child(3) {\n    text-align: left;\n    width: 50%;\n    display: inline-block;\n  }\n}\n.page.news .content__item .copy b {\n  color: #000;\n  font-weight: bold;\n  display: inline-block;\n  background: none;\n}\n.page.news .content__item .copy i {\n  display: inline-block;\n  color: #000;\n  opacity: 0.6;\n  font-style: unset;\n}\n.page.news .content__item .section__background {\n  position: relative;\n  min-height: unset;\n  height: 40vw;\n}\n.page.news .news__item {\n  position: relative;\n}\n.page.news .news__item a {\n  position: absolute;\n  width: calc(100% - 40px);\n  height: calc(100% - 40px);\n  z-index: 3;\n}\n.page.news .news__item a:hover {\n  background-color: unset;\n}\n.page.news .news__item:hover .news__item__content__title {\n  background-color: #55FF9E;\n  color: #000;\n}\n.page.news .news__item__content {\n  position: absolute;\n  bottom: 40px;\n  left: 50px;\n}\n@media (min-width: 970px) {\n  .page.news .news__item__content {\n    bottom: 80px;\n    left: 80px;\n  }\n}\n.page.news .news__item__content__info {\n  color: #FFF;\n}\n.page.news .news__item__content__info .source {\n  font-weight: bold;\n  margin-right: 30px;\n  margin-right: 60px;\n  display: block;\n}\n.page.news .news__item__content__info .date {\n  font-size: 12px;\n}\n.page.news .news__item__content__title {\n  display: inline-block;\n  margin: 10px 0 0 -10px;\n  padding: 5px 10px;\n  background-color: unset;\n  text-decoration: underline;\n  text-decoration-color: #55FF9E;\n  text-underline-position: under;\n  color: #FFF;\n}\n@media (max-width: 969px) {\n  .page.news .news__item__content__title {\n    background-color: #55FF9E;\n    color: #000;\n  }\n}\n.page.news .news__item__background {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n\n.page.culture .page__section.expanded, .page.our-energy .page__section.expanded {\n  padding: 10px;\n  background-color: #f8f8f2;\n  padding: 20px;\n  margin-right: 40px;\n  background-color: #F8F8F3;\n}\n.page.culture .page__section.expanded .culture__grid, .page.our-energy .page__section.expanded .culture__grid {\n  display: -webkit-box; /* Not needed if autoprefixing */\n  display: -ms-flexbox; /* Not needed if autoprefixing */\n  display: flex;\n  margin-left: -20px; /* gutter size offset */\n  width: auto;\n}\n.page.culture .page__section.expanded .culture__grid .grid__item, .page.our-energy .page__section.expanded .culture__grid .grid__item {\n  padding-left: 20px; /* gutter size */\n}\n@media (max-width: 969px) {\n  .page.culture .page__section.expanded .culture__grid .grid__item, .page.our-energy .page__section.expanded .culture__grid .grid__item {\n    width: 100% !important;\n  }\n}\n@media (min-width: 1300px) {\n  .page.culture .page__section.expanded .culture__grid .grid__item, .page.our-energy .page__section.expanded .culture__grid .grid__item {\n    width: auto;\n  }\n}\n.page.culture .page__section.expanded .culture__grid .culture__item:before, .page.our-energy .page__section.expanded .culture__grid .culture__item:before {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: #f8f8f2;\n  pointer-events: none;\n  content: \"\";\n  z-index: 2;\n  opacity: 0;\n  transition: 0.3s opacity ease-out;\n}\n.page.culture .page__section.expanded .culture__grid .culture__item.active:before, .page.our-energy .page__section.expanded .culture__grid .culture__item.active:before {\n  opacity: 1;\n}\n.page.culture .page__section.expanded img, .page.our-energy .page__section.expanded img {\n  display: inherit;\n  width: 100%;\n}\n.page.culture .page__section.expanded .embed, .page.our-energy .page__section.expanded .embed {\n  padding: 10px;\n}\n.page.culture .page__section.expanded .embed a:hover, .page.our-energy .page__section.expanded .embed a:hover {\n  color: unset;\n  background-color: unset;\n}\n.page.culture .page__section.expanded .embed .section__background, .page.our-energy .page__section.expanded .embed .section__background {\n  position: relative;\n}\n.page.culture .culture__item, .page.our-energy .culture__item {\n  position: relative;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n.page.culture .culture__item__description, .page.our-energy .culture__item__description {\n  position: absolute;\n  padding: 10px;\n  width: 100%;\n  height: 100%;\n  transition: 0.2s all ease-out;\n}\n.page.culture .culture__item__description:hover, .page.our-energy .culture__item__description:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n.page.culture .culture__item__description h2, .page.culture .culture__item__description p, .page.our-energy .culture__item__description h2, .page.our-energy .culture__item__description p {\n  font-size: 16px;\n  line-height: 26px;\n  margin: 0;\n  color: #FFF;\n}\n.page.culture .culture__item__description h2 u, .page.culture .culture__item__description p u, .page.our-energy .culture__item__description h2 u, .page.our-energy .culture__item__description p u {\n  color: #FFF;\n}\n.page.culture .culture__item__description h2 u:after, .page.culture .culture__item__description p u:after, .page.our-energy .culture__item__description h2 u:after, .page.our-energy .culture__item__description p u:after {\n  background-color: #FFF;\n}\n.page.culture .people__list__item__description, .page.our-energy .people__list__item__description {\n  left: 15px;\n}\n\n.partners {\n  height: 100vh;\n}\n.partners__content {\n  padding: 0 7.5%;\n  padding-top: 5vh;\n}\n.partners__content p {\n  width: 100%;\n  margin: unset;\n}\n@media (min-width: 1300px) {\n  .partners__content p {\n    width: 60%;\n  }\n}\n@media (min-width: 1300px) {\n  .partners__logos {\n    margin-top: 5vh;\n  }\n}\n.partners__logos img {\n  width: 25%;\n  display: inline-block;\n  transform-origin: top left;\n  margin-bottom: -5vw;\n  max-width: 150px;\n}\n@media (min-width: 1300px) {\n  .partners__logos img {\n    margin-bottom: 0;\n    max-width: 220px;\n    max-height: 10.5vw;\n    width: auto;\n  }\n}\n@media (min-width: 1800px) {\n  .partners__logos img {\n    margin-bottom: 0;\n    width: auto;\n  }\n}\n\n.people__list {\n  padding: 0 7.5%;\n  font-size: 0;\n  padding: 80px 40px;\n}\n.people__list__item {\n  position: relative;\n  width: 100%;\n  display: inline-block;\n  vertical-align: top;\n  cursor: pointer;\n}\n.people__list__item a {\n  width: 100%;\n  height: 100%;\n  background: none;\n  text-decoration: none;\n  display: inline-block;\n  padding: 0;\n}\n.people__list__item:hover .people__list__item__description {\n  opacity: 1;\n}\n.people__list__item__description {\n  position: absolute;\n  z-index: 3;\n  background: rgba(0, 0, 0, 0.5);\n  color: #FFF;\n  width: calc(100% - 40px);\n  height: calc(100% - 40px);\n  opacity: 0;\n  transition: 0.5s opacity ease-out;\n  pointer-events: none;\n  top: 20px;\n  left: 20px;\n}\n.people__list__item__description .description__copy {\n  position: absolute;\n  left: 30px;\n  bottom: 40px;\n}\n.people__list__item__description p {\n  line-height: 24px;\n  margin-top: 0;\n}\n@media (max-width: 969px) {\n  .people__list__item__description p {\n    line-height: 18px;\n  }\n}\n.people__list__item__description p.role {\n  font-weight: bold;\n  margin-top: 10px;\n}\n.people__list__item img {\n  width: 100%;\n  display: inline-block;\n  padding: 20px;\n}\n@media (min-width: 970px) {\n  .people__list__item {\n    width: 33.3333333333%;\n  }\n}\n\n.anti-racism .expand-cta {\n  position: absolute;\n  z-index: 3;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n  bottom: 10vh;\n  font-size: 20px;\n  background: #55FF9E;\n  display: inline-block;\n  padding: 5px;\n  color: #000;\n  cursor: pointer;\n}\n.anti-racism .expand-cta:hover {\n  background: #000;\n  color: #FFF;\n}\n.anti-racism .hero {\n  transition: 0.5s ease-out all;\n}\n.anti-racism .hero__content {\n  position: relative;\n  padding-top: 20vh;\n  margin-bottom: 60px;\n  top: unset;\n  left: unset;\n  transform: unset;\n}\n.anti-racism.expanded .hero {\n  min-height: 50vh;\n}\n.anti-racism.expanded .expand-cta {\n  bottom: 30px;\n}\n.anti-racism .page__section__top {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  width: 100%;\n}\n.anti-racism .expanded-content {\n  position: relative;\n  height: 0;\n  padding: 0 7.5%;\n  overflow: hidden;\n  transition: 0.3s ease-out height;\n}\n.anti-racism .expanded-content.expanded {\n  padding: 0 7.5% 120px 7.5%;\n  height: auto;\n}\n.anti-racism .expanded-content.expanded .expanded {\n  bottom: 0px;\n}\n\n.partners {\n  padding-bottom: 0 !important;\n}\n.partners .headline {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  top: 0;\n  background-color: #55FF9E;\n  color: #000;\n  line-height: 50px;\n  white-space: nowrap;\n  text-transform: uppercase;\n  animation: 8s marquee linear infinite;\n  cursor: default;\n  overflow-x: hidden;\n  display: inline-block;\n}\n@media (min-width: 970px) {\n  .partners .headline {\n    animation: 3s marqueeDesktop linear infinite;\n    line-height: 80px;\n  }\n}\n.partners .headline b {\n  display: unset;\n}\n.partners .headline:before {\n  content: \"Our proud partners ↓\";\n  padding-right: 12px;\n}\n@media (min-width: 970px) {\n  .partners .headline:before {\n    padding-right: 20px;\n  }\n}\n.partners .headline:after {\n  content: \"Our proud partners ↓\";\n  padding-left: 12px;\n}\n@media (min-width: 970px) {\n  .partners .headline:after {\n    padding-right: 20px;\n  }\n}\n.partners .headline:empty {\n  display: none;\n}\n.partners .embedded__media {\n  width: 25%;\n  display: inline-block;\n  padding: 20px 0;\n}\n@media (min-width: 1300px) {\n  .partners .embedded__media {\n    width: 14.2857142857%;\n  }\n}\n\n.map {\n  position: relative;\n  padding: 0 !important;\n}\n.map .headline {\n  position: relative;\n  width: 100%;\n  padding: 60px 7.5%;\n  color: #FFF;\n  background: linear-gradient(270deg, rgb(251, 98, 48) 0%, rgb(252, 91, 65) 40%, rgb(252, 120, 79) 60%, rgb(252, 169, 54) 100%);\n}\n\n.lazyload-wrapper {\n  height: 100%;\n}","// typekit\n@import url(\"https://use.typekit.net/zdq7lvi.css\");\n\n$green: #55FF9E;\n$orange: #FF3B00;\n$lightOrange: #FBB640;\n$grey: #f8f8f2;\n\n* {\n  margin: 0;\n  padding: 0;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin:0;\n  padding:0;\n  height: 100%;\n}\n\nhtml {\n  height: -webkit-fill-available;\n}\n\nbody {\n\tbackground: $grey;\n\tmin-height: 100%;\n  /* mobile viewport bug fix */\n  min-height: -webkit-fill-available;\n}\n\nimg {\n\tdisplay: inherit;\n}\n\nh2 {\n\tfont-weight: unset;\n}\n\n@mixin for-size($size) {\n  @if $size==phone-only {\n    @media (max-width: 969px) {\n      @content;\n    }\n  }\n\n  @else if $size==phone-up {\n    @media (min-width: 970px) {\n      @content;\n    }\n  }\n\n  @if $size==tablet-only {\n    @media (min-width: 899px) and (max-width: 1300px) {\n      @content;\n    }\n  }\n\n  @else if $size==tablet-up {\n    @media (min-width: 900px) {\n      @content;\n    }\n  }\n\n  @else if $size==desktop-up {\n    @media (min-width: 1300px) {\n      @content;\n    }\n  }\n\n  @else if $size==big-desktop-up {\n    @media (min-width: 1800px) {\n      @content;\n    }\n  }\n}\n\n.home,.page {\n\ttransition: .25s transform;\n\t.section__copy, .top {\n\t\ttext-align: left;\n\t\twidth: 95%;\n\t\t.headline {\n\t\t\tfont-weight: unset;\n\t\t\tdisplay: inline;\n\t\t\tfont-size: 6vw;\n\t\t\tline-height: 6.5vw;\n\t\t\t&:nth-child(2){\n\t\t\t\tcolor:#000;\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: '\\A';\n\t\t\t\t\twhite-space:pre;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t  @include for-size(\"phone-up\") {\n\t\t  \tpadding-left: 40px;\n\t\t    width: 40%;\n\t\t    display: inline-block;\n\t\t    vertical-align: top;\n\t\t  }\n\t\t}\n\t}\n}\n\n.image-full-width {\n  img {\n    width: 100% !important;\n  }\n}\n\n.module-2-column {\n\tmargin: 20px 0;\n  img, .looping-video, .module-2-column__image {\n  \twidth: 100%;\n  \tdisplay: inherit;\n  \tmargin-bottom: 20px;\n  \t&:last-child {\n  \t\tmargin-bottom: 0;\n  \t}\n  \t@include for-size(\"phone-up\"){\n  \t\twidth: calc(100% / 2 - 10px) !important;\n  \t\tmargin: 0 20px 0 0 !important;\n  \t\tdisplay: inline-block;\n  \t\tvertical-align: top;\n  \t\t&:last-child {\n  \t\t\tmargin-right: 0 !important;\n  \t\t}\n  \t}\n    object-fit: cover;\n  }\n  .looping-video {\n  \twidth: 100%;\n  \tmargin-top: 20px;\n  \t&:last-child {\n  \t\tmargin-right: 0 !important;\n  \t}\n  }\n\n  .module-2-column__image {\n  \timg {\n  \t\twidth: 100% !important;\n  \t}\n  \t.caption {\n  \t\tdisplay: block !important;\n  \t}\n  }\n}\n\n@mixin gradient($deg) {\n\tbackground: linear-gradient($deg, rgba(251,98,48,1) 0%, rgba(252,91,65,1) 40%, rgba(252,120,79,1) 60%, rgba(252,169,54,1) 100%);\n}\n\n@mixin centerCenter {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n@mixin vertCenter {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n@mixin horzCenter {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  -ms-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n@mixin bubbleEffect () {\n\tanimation: bubble 1s;\n  animation-timing-function: ease-out;\n\t@keyframes bubble {\n\t\t0% { transform: scale(1) }\n\t\t30% { transform: scale(1.3) }\n\t\t50% { transform: scale(1.2) }\n\t\t70% { transform: scale(1.3) }\n\t\t100% { transform: scale(1) }\n\t}\n}\n\nbody {\n\tfont-family: degular, sans-serif;\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\np, .headline, .client-name {\n\tmargin: auto;\n}\n\n.button {\n\tcursor: pointer;\n}\n\n@mixin button {\n\tcursor: pointer;\n}\n\n.headline {\n\tfont-family: degular,sans-serif;\n\tfont-style: normal;\n\tposition: relative;\n  font-size: 4vh;\n  line-height: 4.5vh;\n  text-align: left;\n  margin-bottom: 1.5vh;\n  b {\n\t\tcolor: inherit;\n\t\tfont-weight: 700;\n\t\tfont-style: normal;\n\t\tbackground-color: inherit;\n\t}\n  @include for-size(\"phone-up\"){\n  \tfont-size: 6vw;\n  \tline-height: 6.5vw;\n  \tdisplay: inline-block;\n  \tvertical-align: middle;\n  }\n}\n\n.caption {\n\tfont-size: 16px;\n\t// padding: 20px;\n\tmargin: 10px !important;\n\twidth: unset !important;\n\t@include for-size(\"phone-up\"){\n\t\tfont-size: 21px;\n\t\tpadding: 60px 7.5%;\n\t}\n}\n\n.looping-video, .standard-video {\n\tmargin: 20px 0;\n}\n\nb {\n\tdisplay: inline-block;\n}\n\np {\n\tposition: relative;\n\tz-index: 1;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  display: block;\n  margin-top: 20px;\n  &.size-2 {\n  \tfont-size: 18px !important;\n  }\n  &:first-child {\n  \tmargin-top: 0;\n  }\n  &:empty {\n  \tdisplay: none !important;\n  }\n\n  @include for-size(\"phone-up\"){\n  \tfont-size: 24px;\n  \tline-height: 32px;\n  \tvertical-align: middle;\n  }\n}\n\n.background {\n\t&:empty {\n  \tdisplay: none;\n  }\n}\n\n.hide {\n\tdisplay: none;\n}\n\n.expand-icon {\n\t@include button;\n\tfilter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\ttransform-origin: left;\n\tdisplay: none;\n\twidth: 6vh;\n\tmargin-top: 15px;\n  &:hover {\n\t\t@include bubbleEffect;\n\t}\n\t@include for-size(\"phone-up\"){\n\t\tposition: absolute;\n\t\tbottom: 8px;\n\t\twidth: 5vw;\n\t\theight: auto;\n\t\tmargin-left: 2.5vw;\n\t}\n}\n\na {\n\tposition:relative;\n\ttext-decoration-color: $green;\n\ttext-underline-position: under;\n\tpadding: 5px;\n\ttext-indent: -5px;\n\tcolor: #000;\n\t&.size-2 {\n  \tfont-size: 18px !important;\n  }\n\t&:hover {\n\t\tbackground-color: $green;\n\t\t&:after {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.image-link {\n\t\t&:hover {\n\t\t\tbackground-color: unset;\n\t\t}\n\t}\n}\n\n.gradient-theme, .content__item.gradient-theme, .embed__item.gradient-theme {\n\tcolor: #FFF;\n\t.headline {\n\t\tcolor:#FFF;\n\t\t&:nth-child(2){\n\t\t\tcolor:#000;\n\t\t}\n\t}\n\ta {\n\t\tcolor: $green;\n\t}\n\t.expand-icon {\n\t\tcolor: #FFF;\n\t}\n\t@include gradient(270deg);\n}\n\n.dark-theme, .content__item.dark-theme, .embed__item.dark-theme {\n\tcolor: #FFF;\n\tbackground-color: #000;\n\t.headline {\n\t\tcolor: #FFF;\n\t\t&:nth-child(2){\n\t\t\tcolor:#FFF;\n\t\t}\n\t}\n\ta {\n\t\tcolor: $green;\n\t}\n\t.expand-icon {\n\t\tcolor: #FFF;\n\t}\n}\n\n.light-theme, .content__item.light-theme, .embed__item.light-theme {\n\tcolor:#000;\n\ta {\n\t\tcolor:#000;\n\t}\n\t.headline {\n\t\tcolor: $orange;\n\t}\n\n\t.expand-icon {\n\t\tcolor: #000;\n\t}\n\n\tbackground-color: #F8F8F3;\n}\n\n@keyframes bounce {\n\t0%   { margin-top: 0; }\n  30%  { margin-top: -40px; }\n  50%  { margin-top: -15px; }\n  100% { margin: 0; }\n}\n\n@keyframes fadeIn {\n\t0% { opacity: 0; }\n\t100% { opacity: 1; }\n}\n\n@keyframes fadeOff {\n\t0% { opacity: 1; }\n\t100% { opacity: 0; }\n}\n\n@keyframes growRight {\n\t0% {\n\t\twidth: 0;\n\t}\n\t100% {\n\t\twidth: 100%;\n\t}\n}\n",".app {\n  position: absolute;\n  width: 100%;\n  &.home {\n    height: 100%;\n  }\n  &:after {\n    content: \"\";\n    background: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.2));\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100vw;\n    height: 100px;\n    z-index: 3;\n    pointer-events: none;\n  }\n\n  &.nav-expanded {\n    .home, .page {\n      transform: translateX(-300px);\n      @include for-size(\"phone-up\"){\n        transform: translateX(-500px);\n      }\n    }\n  }\n}",".nav {\n  position: fixed;\n  width: 100vw;\n  top:0;\n  left: 0;\n  z-index: 4;\n\n  &.orange {\n    .nav__logo {\n      filter: unset;\n    }\n\n    .nav__menu {\n      .nav__menu__button {\n        &.close {\n          .line {\n            background-color: #FFF;\n          }\n        }\n        .line {\n          background-color: $orange;\n        }\n      }\n    }\n  }\n\n   a {\n    color: unset;\n    text-decoration: none;\n    &:hover {\n      background: none;\n    }\n   }\n\n  &__logo {\n    position: absolute;\n    width: 65px;\n    transition: .5s all ease-out;\n    filter: brightness(0) invert(1);\n    user-select: none;\n    top: 15px;\n    left: 15px;\n    @include for-size(\"desktop-up\") {\n      width: 75px;\n    }\n\n    &.hidden {\n      transform:translateY(-300px);\n    }\n\n    img {\n      width: 100%;\n    }\n  }\n\n  &__menu {\n    font-size: 24px;\n\n    @include for-size(\"phone-up\"){\n      font-size: 30px;\n    }\n    &__expanded {\n      position: fixed;\n      transition: .25s transform;\n      top: 0;\n      @include gradient(120deg);\n      padding: 4vh 20px;\n      transform: translateX(100vw);\n      width: 300px;\n      height: 100vh;\n      @include for-size(\"phone-up\"){\n        width: 500px;\n      }\n\n      &.active {\n        transform: translateX(calc(100vw - 300px));\n        @include for-size(\"phone-up\"){\n          transform: translateX(calc(100vw - 500px));\n        }\n      }\n\n      &__list {\n        color: #FFF;\n        position: relative;\n        // @include vertCenter;\n        list-style: none;\n        text-align: center;\n\n        &.social {\n          transform: none;\n          top: unset;\n          margin-top: 10vh;\n\n          &:before {\n            position: absolute;\n            left: 10%;\n            top: -5vh;\n            content: \"\";\n            width: 80%;\n            height: 20px;\n            border-top: solid 2px #FFF;\n          }\n        }\n\n        &.global {\n          margin-top: 5vh;\n\n          li {\n            display: inline-block;\n            font-size: 14px;\n            margin: 0 10px;\n            &.global{\n              font-size: 24px;\n              display: block;\n              width: 50%;\n              margin: 20px auto;\n\n              @include for-size(\"phone-up\"){\n                font-size: 30px;\n                width: 40%;\n              }\n            }\n\n            &::after {\n              height: 1px;\n            }\n            @include for-size(\"phone-up\"){\n              font-size: 15px;\n              margin: 0 20px;\n            }\n          }\n        }\n\n        li {\n          position: relative;\n          display: table;\n          margin: 3vh auto;\n          cursor: pointer;\n\n          &:first-child {\n            margin-top: 0;\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n\n          &:after {\n            transition: .3s all ease-in-out;\n            position: absolute;\n            bottom: -8px;\n            left: 0;\n            height: 2px;\n            background-color: #FFF;\n            content: \"\";\n            width: 0;\n          }\n\n          &:hover {\n            &:after {\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n\n    &__button {\n      position: relative;\n      width: 30px;\n      height: 15px;\n      float: right;\n      cursor: pointer;\n      z-index: 3;\n      user-select: none;\n      top: 15px;\n      right: 15px;\n\n      &:hover {\n        .line {\n          &:first-child {\n            transform: translateY(3px);\n          }\n          &:last-child {\n            transform: translateY(-3px);\n          }\n        }\n      }\n\n      &.close {\n        .line {\n          background-color: #FFF;\n          &:first-child {\n            top: 50%;\n            transform: rotate(45deg);\n          }\n          &:last-child {\n            top: 50%;\n            transform: rotate(-45deg);\n          }\n        }\n      }\n\n      .line {\n        width: 100%;\n        height: 3px;\n        background-color: #FFF;\n        position: absolute;\n        transition: .2s ease-out all;\n\n        &:nth-child(1) {\n          top: 0;\n          left: 0;\n        }\n\n        &:nth-child(2) {\n          bottom: 0;\n          left: 0;\n        }\n      }\n    }\n  }\n}","$desktopHeight: 90px;\n$mobileHeight: 70px;\n\n.footer {\n\tposition: absolute;\n\tleft: 0;\n\tz-index: 3;\n\tbackground-color: $orange;\n\tpadding: 10px;\n\tcolor: #FFF;\n\twidth: 100vw;\t\t\n\theight: $mobileHeight;\n\tbox-shadow: inset 0px 25px 30px -13px rgba(0,0,0,0.3);\n\tfont-size: 15px;\n\topacity: 0;\n\ttransition: .5s opacity ease-out;\n\n\t&.loaded {\n\t\topacity: 1;\n\t}\n\n\t@include for-size(\"phone-up\"){\n\t\tpadding: 20px 40px;\n\t\theight: unset;\n\t\theight: $desktopHeight;\n\t\tfont-size: 24px;\n\t}\n\n\t&__column {\n\t\twidth: 50%;\n\t\tdisplay: inline-block;\n\t\theight: 100%;\n\t\ttransition: .3s all ease-out;\n\t\tmargin-top: 10px;\n\n\t\t@include for-size(\"phone-only\"){\n\t\t\tmargin-top: 0;\n\t\t}\n\n\t\t&.left, &.right {\n\t\t\twhite-space: nowrap;\n\t\t\ta {\n\t\t\t\tcolor:#FFF;\n\t\t\t\tpadding: 0;\n\t\t\t\ttext-decoration-color: #FFF;\n\t\t\t\ttext-decoration: none;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.left {\n\t\t\tposition: relative;\n\t\t\tz-index: 3;\n\t\t\twidth: 60%;\n\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\twidth: 50%;\n\t\t\t}\n\n\t\t\t.footer__email, .terms-privacy {\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-bottom: unset;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.footer__email {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\twhite-space: nowrap;\n\t\t\t}\n\n\t\t\t.terms-privacy {\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\tline-height: 15px;\n\t\t\t\t}\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\tmargin-left: 2vw;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t}\n\t\t\t\ta {\n\t\t\t\t\tcolor: #dbdbdb;\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.right {\n\t\t\ttext-align: right;\n\t    width: 40%;\n\t    left: 0;\n\t    top: 0;\n\t    height: 100%;\n\t    display: inline-block;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tposition: relative;\n\t\t\t}\n\t\t\t@include for-size(\"phone-only\") {\n\t\t\t\tline-height: 15px;\n\t\t\t\twidth: 50%;\n\t\t\t\tvertical-align: top;\n\t\t\t\t.social__link {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.social__link {\n\t\t\t\t@include button;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\tmargin-left: 2.4vw;\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",":root {\n  --textIndent: 0;\n}\n\n@keyframes marquee {\n  0% { \n    text-indent: 0;\n  }\n  100% {\n    text-indent: var(--textIndent);\n  }\n}\n\n@keyframes marqueeDesktop {\n  0% { \n    text-indent: 0;\n  }\n  100% {\n    text-indent: var(--textIndent);\n  }\n}\n\n.banner {\n  // height: 100px;\n\tbackground-color: $green;\n  color: #000;\n  white-space: nowrap;\n  text-transform: uppercase;\n  padding: 10px 0;\n  overflow-x: hidden;\n  animation: 8s marquee linear infinite;\n  font-size: 32px;\n  line-height: 50px;\n\n  @include for-size(\"big-desktop-up\") {\n    height: 100px;\n    animation: 8s marqueeDesktop linear infinite;\n    font-size: 80px;\n    line-height: 70px;\n  }\n\n  span {\n    margin-left: 10px;\n  }\n}",".content__item {\n  // &:before {\n  //   position: fixed;\n  //   width: 100%;\n  //   height: 100%;\n  //   top:0;\n  //   left:0;\n  //   background: $grey;\n  //   pointer-events: none;\n  //   content:\"\";\n  //   z-index: 3;\n  //   opacity: 0;\n  //   transition: .5s opacity ease-out;\n  // }\n  &.active {\n    &:before {\n      opacity: 1;\n    }\n  }\n  &__section {\n    &.description {\n      height: 100vh;\n      .section__copy {\n        &.fade {\n          p {\n            mask-image: -webkit-gradient(linear, left 20%, left 70%, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));\n            margin-bottom: 0;\n\n            @include for-size(\"phone-up\") {\n              mask-image: none;\n              margin-top: 40px;\n            }\n          }\n        }\n\n        @include vertCenter;\n      }\n    }\n\n    &.expanded {\n      .headline, p {\n        color: inherit !important;\n      }\n      p {\n        width: unset;\n        display: block;\n      }\n      .embed__item {\n        &:last-child {\n          padding-bottom: 70px;\n        }\n      }\n    }\n\n    .section__background {\n      max-height: 100vh;\n    }\n  }\n}\n\n.content__item {\n  position: relative;\n  width: 100%;\n  margin-top: 0;\n  scroll-snap-align: start;\n  &__section {\n    position: relative;\n\n    &.description {\n      padding: 70px 0;\n\n      .section__copy {\n        padding: 0 7.5%;\n      }\n    }\n\n    // copy container in both description and expanded\n    .section__copy {\n      position: relative;\n      z-index: 2;\n    }\n\n    .section__background {\n      position: absolute;\n      top: 0;\n      z-index: 0;\n      width: 100%;\n      height: 100%;\n      min-height: 100vh;\n      max-height: unset;\n\n      img, video {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}",".carousel-container {\n  position: relative;\n  height: inherit;\n\n  &.autoplay.speed-1 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 1s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-2 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 2s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-3 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 3s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-4 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 4s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-5 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 5s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-6 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 6s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-7 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 7s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-8 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 8s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-9 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 9s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay.speed-10 {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation-duration: 10s;\n          }\n        }\n      }\n    }\n  }\n\n  &.autoplay {\n    .flickity-page-dots {\n      .dot {\n        &.is-selected {\n          &:before {\n            animation: 3s growRight forwards linear;\n          }\n        }\n      }\n    }\n  }\n\n  .content__item {\n    height: 100%;\n  }\n\n  .carousel {\n    overflow: hidden;\n    height: 100%;\n    outline: none;\n\n    &.hidden {\n      display: none;\n    }\n\n    &::-webkit-scrollbar {\n      height: 0px;\n      width: 0px;\n      background: transparent;\n    }\n\n    &__item {\n      position: relative;\n      width: 100%;\n      height: 100%;\n      margin-top: 0;\n      display: inline-block;\n      opacity: 0;\n      transition: opacity 1s ease-out;\n\n      &.loaded {\n        opacity: 1;\n      }\n\n      a {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        padding: 0;\n        text-indent: unset;\n        color: unset;\n\n        &:hover {\n        \tbackground: unset;\n        }\n      }\n\n      &__title {\n        position: absolute;\n        z-index: 2;\n        font-size: 21px;\n        bottom: 40px;\n        left: 7%;\n        cursor: pointer;\n        a {\n        \tposition: relative;\n        }\n        &:hover {\n\t      \t.main {\n\t      \t\tbackground-color: transparent;\n\t      \t\ttext-decoration: underline;\n\t      \t\ttext-underline-position: under;\n\t      \t\ttext-decoration-color: $green;\n\t      \t\tcolor: #FFF;\n\t      \t}\n\t      }\n        @include for-size(\"phone-up\") {\n        \tleft: 3%;\n        }\n        .main {\n        \tbackground-color: $green;\n        \tpadding: 7px 7px 5px 7px;\n        \tcolor: #000;\n        \tmargin-right: 10px;\n          line-height: 30px;\n        }\n        .subtitle {\n        \tposition: relative;\n        \ttop: 1px;\n        \tbackground-color: none !important;\n        \tcolor: #FFF;\n        \tvertical-align: bottom;\n        \tline-height: 40px;\n        \ta {\n        \t\ttext-decoration: none;\n        \t}\n        \t@include for-size(\"phone-only\") {\n        \t\tdisplay: block;\n        \t\tmargin-top: 20px;\n        \t\tline-height: 30px;\n        \t}\n        }\n      }\n\n      &__background {\n        position: relative;\n        width: 100%;\n        height: 100%;\n\n        video {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n\n  .flickity-page-dots {\n    position: relative;\n    z-index: 3;\n    display: none;\n    bottom: 15px;\n\n    @include for-size(\"desktop-up\") {\n      bottom: 20px;\n    }\n\n    .dot {\n      opacity: 1;\n      position: relative;\n      border-radius: 12px;\n      margin: 0 .2vw;\n      background: rgba(255, 255, 255, 0.3);\n      height: 0.5vw;\n      min-height: 5px;\n\n      &:first-child {\n        margin-left: 0;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      &.is-selected {\n        background: rgba(255, 255, 255, 0.3);\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          top: 0;\n          left: 0;\n          height: 100%;\n          width: 100%;\n          border-radius: 12px;\n          background: rgba(255, 255, 255, 0.6);\n          pointer-events: none;\n        }\n      }\n    }\n  }\n}",".hero {\n\tposition: relative;\n\twidth: 100%;\n\tmin-height: 100vh;\n\tbackground-size: cover;\n\tbackground-position: center center;\n\n\t&.offices {\n\t\tp {\n\t\t\tmargin: 80px 0 0 .5vw;\n\t\t}\n\t\t.expand-icon {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&__content {\n\t\tposition: absolute;\n\t\t@include centerCenter;\n\t\tfont-size: initial;\n    color: #FFF;\n    width: 100%;\n    padding: 0 7.5%;\n    .headline {\n    \t@include for-size(\"phone-up\"){\n    \t\tfont-size: 6vw;\n\t    \tline-height: 6.5vw;\n    \t}\n    }\n    .headline, p {\n    \tcolor: #FFF;\n    \t@include for-size(\"phone-up\"){\n\t    \tdisplay: block;\n\t    \tmargin: unset;\n\t  \t}\n    }\n\n    .headline {\n    \tdisplay: block;\n\n    \t&:nth-child(2){\n    \t\t@include for-size(\"phone-up\"){\n    \t\t\tdisplay: inline;\n    \t\t}\n    \t}\n    }\n\n    .copy {\n    \t@include for-size(\"phone-up\"){\n    \t\twidth: 95%;\n    \t\tdisplay: inline-block;\n    \t}\n    }\n    p {\n    \tmargin-top: 20px;\n    \tdisplay: block;\n    \ta {\n    \t\tmargin-bottom: 10px;\n    \t\tcolor: #FFF !important;\n    \t\ttext-decoration-color: #FFF !important;\n    \t\t&:hover {\n    \t\t\tcolor: #000 !important;\n    \t\t\ttext-decoration-color: #000 !important;\n    \t\t}\n    \t}\n    }\n\t}\n}",".text-block {\n\tpadding: 60px 7.5%;\n\n\t.headline {\n\t\tmargin: 0;\n\t}\n}",".custom-slideshow {\n\tcolor:#FFF;\n\tmin-height: 100vh;\n\n\t.headline {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t&__content {\n\t\tposition: absolute;\n\t\tz-index: 2;\n\t\tpadding: 0 7.5%;\n\t\t@include vertCenter;\n\t\t@include for-size(\"phone-up\"){\n\t\t\twidth: 80%;\n\t\t}\n\n\t\tp {\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: 90%;\n\t\t\t\tmargin: unset;\n\t\t\t}\n\t\t}\n\n\t\tspan {\n\t\t\tfont-size: 16px;\n  \t\tline-height: 24px;\n  \t\t@include for-size(\"phone-up\"){\n\t\t  \tfont-size: 24px;\n\t\t  \tline-height: 32px;\n\t\t  \tvertical-align: middle;\n\t\t  }\n\t\t}\n\n\t}\n\n\t.flickity-slider {\n\t\ttransform: none !important;\n\n\t\t.slider__item {\n\t\t\twidth: 100vw;\n\t\t\theight: 100vh;\n\t\t\tleft: 0 !important;\n\t\t  opacity: 0;\n\t\t  transition: opacity 1s ease-out;\n\t\t  z-index: -1;\n\t\t  transform: none !important;\n\t\t  pointer-events: none;\n\t\t  &.is-selected{ \n\t\t  \topacity: 1;\n\t\t  \tz-index: 0;\n\t\t  }\n\t\t}\n\n\t\timg {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n\n\t.flickity-page-dots {\n\t\tbottom: 50px;\n\n\t\t.dot {\n\t\t\tbackground: #FFF;\n\t\t\topacity: .3;\n\n\t\t\t&.is-selected {\n\t\t\t\tbackground: #FFF;\n\t\t\t\topacity: .8;\n\t\t\t}\n\t\t}\n\t}\n}",".instagram-feed {\n\n\t&__banner {\n\t\tpadding: 80px 0;\n\t\tmax-width: 670px;\n\t\twidth: 100%;\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}",".page.home {\n\tposition:relative;\n  overflow: scroll;\n  // height: 100vh; // uncomment to enable snap\n  height: 100%;\n  scroll-snap-type: mandatory;\n  scroll-snap-points-y: repeat(100vh);\n  scroll-snap-type: y mandatory;\n  opacity: 0;\n  animation: 1s fadeIn ease-in forwards;\n\n  .copy, .custom-slideshow .headline {\n    @include button;\n\n    &:hover {\n      .expand-icon {\n        @include bubbleEffect;\n      }\n    }\n  }\n\n  &::-webkit-scrollbar {\n    height: 0px;\n    width: 0px;\n    background: transparent;\n  }\n\n  .expand-icon {\n    display: block;\n    @include for-size(\"phone-up\"){\n      display: inline-block;\n    }\n  }\n}",".page.about {\n\tpadding-top: 5vw;\n\t&__section {\n\t\t&.top {\n\t\t\theight: calc(100vh - 5vh);\n\t\t}\n\t}\n\t.expanded {\n\t\tpadding: 0 7.5%;\n\t\tbackground-color: #000;\n\t\toverflow: hidden;\n\n\t\t.parallax {\n\t\t\theight: calc(100vh * var(--imageNum) - 200px);\n\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\theight: calc(600px * var(--imageNum));\n\t\t\t}\n\t\t\t&__copy {\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 4;\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\twidth: 63%;\n\t\t\t\t}\n\n\t\t\t\t.link {\n\t\t\t\t\t// font-size: 6vh;\n\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\t@include button;\n\t\t\t\t\tmargin-top: -2vh;\n\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\t}\n\t\t\t\t\t@media (max-height: 600px) {\n\t\t\t\t\t\tfont-size: 25px;\n\t\t\t\t\t\tline-height: 32px;\n\t\t\t\t\t}\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t.expand-icon {\n\t\t\t\t\t\t\t@include bubbleEffect;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.expand-icon {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\twidth: 30px;\n\t\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\t\twidth: 40px;\n\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__images {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\twidth: 100vw;\n\t\t\theight: 100%;\n\t\t\tmargin: 0 0 0 -7.5%;\n\t\t\tpadding: 0;\n\t\t\t&:before {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent:\"\";\n\t\t\t\tbackground: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 100%);\n\t\t\t\topacity: .75;\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 200px;\n\t\t\t\tz-index: 3;\n\t\t\t}\n\n\t\t\t&:after {\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent:\"\";\n\t\t\t\tbackground: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 20%, rgba(0,0,0,0) 100%);\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 200px;\n\t\t\t\tz-index: 3;\n\t\t\t\tbottom: 0;\n\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\tbottom: 50px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.parallax-image {\n\t\t\t\tposition: relative;\n\t\t\t\tbackground-size: cover;\n\t\t\t\theight: 100vh;\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\theight: 600px;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tcontent:\"\";\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tbackground: rgba(0,0,0,0.2);\n\t\t\t\t\tz-index: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t}\n\n\t\tp {\n\t\t\tposition: relative;\n\t\t\tz-index: 2;\n\t\t\tfont-weight: 400;\n\t\t\tmargin: 12vh 0;\n\t\t\tfont-size: 32px;\n\t\t\tline-height: 40px;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tmargin: 7vw 0;\n\t\t\t\tfont-size: 40px;\n\t\t\t\tline-height: 45px;\n\t\t\t}\n\t\t\tb {\n\t\t\t\tcolor:$green;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n}",":root {\n  --imageNum: 0;\n}\n\n.page {\n\twidth: 100%;\n\n\t.expanded__bottom {\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\tmargin-top: 80px;\n\t}\n\n\t&.culture {\n\t\t.happenings {\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t.hero {\n\t\t\t&.edi {\n\t\t\t\tmin-height: unset;\n\t\t\t}\n\t\t\t&__content {\n\t\t\t\tposition: relative;\n\t\t\t\ttop: unset;\n\t\t\t\tleft: unset;\n\t\t\t\ttransform: unset;\n\t\t\t\tpadding: 80px 7.5%;\n\t\t\t}\n\t\t\t.headline {\n\t\t\t\tb {\n\t\t\t\t\tcolor:$green;\n\t\t\t\t\tfont-weight: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t\tp {\n\t\t\t\tmargin: 5vw 0;\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\twidth: 60%;\n\t\t\t\t}\n\t\t\t}\n\t\t\ta {\n\t\t\t\tbackground: $green;\n\t\t\t\tcolor: #000 !important;\n\t\t\t\ttext-decoration: unset;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor:#FFF !important;\n\t\t\t\t\tbackground: none;\n\t\t\t\t\ttext-decoration: underline !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&.terms-privacy {\n\t\tpadding: 100px 10% 150px 10%;\n\t\t* {\n\t\t\tfont-size: 18px;\n\t\t\tline-height: 24px;\n\t\t\tfont-weight: unset;\n\t\t}\n\n\t\th1 {\n\t\t\tfont-size: 24px;\n\t\t\tmargin-bottom: 20px;\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\th2, h3 {\n\t\t\tmargin: 10px 0;\n\t\t\ttext-decoration: underline;\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\tp {\n\t\t\tmargin: 0;\n\t\t}\n\n\t\tul {\n\t\t\tmargin: 10px 0;\n\t\t}\n\n\t\tli {\n\t\t\tmargin-left: 20px;\n\t\t}\n\t\t\n\t\t.footer {\n\t\t\tbottom: 0;\n\t\t}\n\t}\n\n\t&.list {\n\t\t.content__item {\n\t\t\t&:nth-last-of-type(2) {\n\t\t\t\t.expand-icon {\n\t\t\t\t\tbottom: -35px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&.home {\n\t\theight: 100%;\n\t\tmin-height: unset;\n\t\t.footer {\n\t\t\tmargin-top: -70px;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tmargin-top: -90px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.strategy-studio {\n\t\t.content__item {\n\t\t\t&.strategy-studio {\n\t\t\t\t.headline {\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tcolor: #FFF;\n\t\t\t\t\tfont-size: 4vw;\n\t\t\t\t\tline-height: 4.5vw;\n\n\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\t\tline-height: 45px;\n\t\t\t\t\t}\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t}\n\t\t\t\t\t&:first-child {\n\t\t\t\t\t\tfont-size: 6vw;\n\t\t\t\t\t\tline-height: 5vw;\n\t\t\t\t\t\ttransform: none;\n\n\t\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\t\tfont-size: 60px;\n\t\t\t\t\t\t\tline-height: 55px;\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(n + 3):nth-child(-n + 7) {\n\t\t\t\t\t\tline-height: 3vw;\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\t\twhite-space: unset;\n\t\t\t\t\t\t\tfont-size: 30px;\n\t\t\t\t\t\t\tline-height: 35px;\n\t\t\t\t\t\t\tmargin-bottom: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(2) {\n\t\t\t\t\t\tmargin-bottom: 3vw;\n\t\t\t\t\t\ttransform: scale(0.6);\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\t\twhite-space: unset;\n\t\t\t\t\t\t\ttransform: scale(1);\n\t\t\t\t\t\t\tfont-size: 25px;\n\t\t\t\t\t\t\tline-height: 30px;\n\t\t\t\t\t\t\tmargin-bottom: 50px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\ttransform: scale(0.8);\n\t\t\t\t\ttransform-origin: left;\n\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\ttransform: scale(1);\n\t\t\t\t\t}\n\t\t\t\t\t&:nth-child(8){\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tpadding-top: 4vw;\n\n\t\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\t\tfont-size: 30px;\n\t\t\t\t\t\t\tline-height: 35px;\n\t\t\t\t\t\t}\n\t\n\t\t\t\t\t\t&:after {\n\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttransform:rotate(90deg);\n\t\t\t\t\t\t\tbackground-image:url('../images/arrow.svg');\n\t\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\t\twidth: 30px;\n\t\t\t\t\t\t\theight: 26px;\n\t\t\t\t\t\t\tbottom: 5px;\n\t\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\t\tfilter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);\n\t\t\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\t\t\theight: 52px;\n\t\t\t\t\t\t\t\tbottom: 20px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.strategy-studio-contact {\n\t\t\t\t.top {\n\t\t\t\t\tpadding-top: 0;\n\n\t\t\t\t\tp {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\t\twidth: unset;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&__section {\n\t\t\t\t&.top {\n\t\t\t\t\tpadding: 140px 7.5% 80px 7.5%;\n\t\t\t\t}\n\t\t\t\t&.expanded {\n\t\t\t\t\tpadding: 80px 7.5%;\n\t\t\t\t\tbackground-color: #000;\n\t\t\t\t\tp {\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tz-index: 2;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tmargin: 0 0 12vh 0;\n\t\t\t\t\t\tfont-size: 32px;\n\t\t\t\t\t\tline-height: 40px;\n\t\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\t\tmargin: 0 0 7vw 0;\n\t\t\t\t\t\t\tfont-size: 40px;\n\t\t\t\t\t\t\tline-height: 45px;\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tb {\n\t\t\t\t\t\t\tcolor:$green;\n\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.embedded__media {\n\t\tposition: relative;\n\t\theight: 100%;\n\t\t&__description {\n\t\t\tposition: absolute;\n\t\t\tpadding: 20px;\n\t\t\ttransition: .2s all ease-out;\n\t\t\topacity: 0;\n\t\t\tpointer-events: none;\n\t\t\twidth: calc(100% - 20px);\n\t\t\theight: 100%;\n\t\t\twhite-space: pre-wrap;\n\t\t}\n\t}\n\n\t&.close-visible {\n\t\t&:before {\n\t\t\tcontent:\"\";\n\t\t\tposition: fixed;\n\t\t\tz-index: 3;\n\t\t\theight: 100px;\n\t\t\twidth: 100%;\n\t\t\tbottom: 0;\n\t\t\tbackground: linear-gradient(to bottom, transparent 0%, rgba(0, 0, 0, 0.2));\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\n\t&__section {\n\t\tposition: relative;\n\t\twidth: 100%;\n\n\t\t&.expanded {\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\tvideo {\n        width: 100%;\n      }\n\n      .back-btn, .more-btn {\n      \tposition: absolute;\n      \t\n      \tdisplay: inline-block;\n      \ta {\n      \t\tbackground-color: $green;\n      \t\tpadding: 7px 7px 5px 7px;\n      \t\t&:hover {\n      \t\t\tbackground-color: unset;\n      \t\t}\n      \t}\n      }\n      .back-btn {\n      \tleft: 0;\n      }\n      .more-btn {\n      \tright: 0;\n      }\n\t\t}\n\n\t\t&.top {\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tmargin-top: 100px;\n\t\t\t}\n\t\t\t.headline {\n\t\t\t\tbr {\n\t  \t\t\t@include for-size(\"big-desktop-up\") {\n\t  \t\t\t\tcontent: \" \";\n\t  \t\t\t\t&:after {\n\t  \t\t\t\t\tcontent:\" \";\n\t  \t\t\t\t}\n\t  \t\t\t}\n\t  \t\t}\n\n\t  \t\t&:nth-child(3){\n\t  \t\t\tdisplay: block;\n\t  \t\t\tpadding-top: 4vw;\n\n\t  \t\t\t&:after {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\ttransform:rotate(90deg);\n\t\t\t\t\t\tbackground-image:url('../images/arrow.svg');\n\t\t\t\t\t\tbackground-size: cover;\n\t\t\t\t\t\twidth: 30px;\n\t\t\t\t\t\theight: 26px;\n\t\t\t\t\t\tbottom: 5px;\n\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\tfilter: invert(97%) sepia(74%) saturate(935%) hue-rotate(67deg) brightness(103%) contrast(100%);\n\t\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\t\theight: 52px;\n\t\t\t\t\t\t\tbottom: 20px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t  \t\t}\n\t\t\t}\n\t\t\t.copy {\n\t\t\t\tpadding: 70px 7.5%;\n\t\t\t\tmargin-top: 50px;\n\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t@include vertCenter;\n\t\t\t\t\tmargin-top: -50px;\n\t\t\t\t}\n\n\t\t\t\tp {\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\tmargin-top: 40px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.embed {\n\t\t\tpadding: 70px 7.5%;\n\t\t\t&:empty {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t.copy {\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\n\t\t.section__background {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\n\t\t\timg, video {\n\t\t\t\twidth: 100vw;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\n\t\t.content {\n\t\t\tpadding: 0 5%;\n\t\t}\n\n\t\t.client-name {\n\t\t\tmargin: 20px auto;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tmargin: 0;\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 50%;\n\t\t\t}\n\t\t}\n\n\t\t// custom styles per slug\n\t\t&.top {\n\t\t\tdisplay: inline-block;\n\t\t\ttransition: .3s all ease-out;\n\t\t\tpadding-top: 100px;\n\t\t\theight: 100vh;\n\t\t}\n\n\t\t.content {\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t}\n\t\t.copy, .content {\n\t\t\tposition: relative;\n\t\t\tmargin: auto;\n\t\t\tz-index: 2;\n\t\t}\n\t}\n\n  .close {\n  \tposition: fixed;\n  \tbottom: 30px;\n  }\n}",".page.work {\n\theight: unset;\n\n\t@include for-size(\"phone-up\"){\n\t\tpadding-bottom: 40px;\n\t}\n\n\t.hero {\n\t\tmargin-bottom: 10px;\n\t}\n\t.footer {\n\t\tposition: absolute;\n\t\tbottom: -130px;\n\t\t@include for-size(\"phone-up\"){\n\t\t\tbottom: -60px;\n\t\t}\n\t}\n\t.content__item {\n\t\tpadding: 10px 20px;\n\t\t&:hover {\n\t\t\t.section__background .embedded__media .embedded__media__description {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t\t.description {\n\t\t\theight: unset;\n\t\t\tpadding-bottom: 40vw;\n\t\t}\n\t}\n\t.page__section {\n\t\t&.top {\n\t\t\tdisplay: none;\n\t\t}\n\t\t.client-name {\n\t\t\tmargin-bottom: 5px;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tpadding-left: 40px;\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.section__background {\n\t\tmin-height: unset;\n\t\t.embedded__media {\n\t\t\theight: 100%;\n\t\t\t.embedded__media__description {\n\t\t\t\tbackground: rgba(0,0,0,0.4);\n\t\t\t\tcolor:#FFF;\n\t\t\t\twidth: 100%;\n\n\t\t\t\t.client {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.expanded {\n\t\tpadding: 120px 20px 50px 20px !important;\n\t\t@include for-size(\"phone-only\"){\n\t\t\tpadding-top: 80px !important;\n\t\t\tpadding-bottom: 0 !important;\n\t\t}\n\t\tmax-width: 1800px;\n\t\tmargin: auto;\n\t\tp {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t\t.embedded__media {\n\t\t\tmargin: 20px 0;\n\t\t\tdisplay: grid;\n\t\t\timg {\n\t\t\t\torder: 1;\n\t\t\t}\n\t\t\t.caption {\n\t\t\t\torder: 2;\n\t\t\t}\n\t\t}\n\t\t.headline {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-left: -2px;\n\t\t\tmargin-bottom: 0px;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: 60%;\n\t\t\t\tmargin-left: -5px;\n\t\t\t\tpadding: 0 5% 0 40px;\n\t\t\t\tvertical-align: top;\n\t\t\t}\n\t\t}\n\t\tp {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin: 20px 0;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: 35%;\n\t\t\t}\n\t\t\t@include for-size(\"big-desktop-up\"){\n\t\t\t\twidth: 40%;\n\t\t\t\tpadding-left: 20px;\n\t\t\t}\n\t\t}\n\t}\n}","// .page.locations, .page__section.locations, .page.contact {\n// \tmin-height: unset;\n// }\n\n.contact {\n\tmin-height: 100vh;\n\tcolor:#FFF;\n\tbackground-size: cover;\n\n\t&__content {\n\t\tposition: absolute;\n\t\t@include horzCenter;\n\t\tfont-size: initial;\n    color: #FFF;\n    width: 100%;\n    padding: 13vh 7.5% 0 7.5%;\n\n    .header-copy {\n    \tmargin-bottom: 2vh;\n    }\n\t}\n\n\t.headline {\n\t\twidth: 100%;\n\t\t@include for-size(\"phone-up\"){\n\t\t\twidth: 60%;\n\t\t}\n\t}\n\n\tp {\n\t\t@include for-size(\"phone-up\"){\n\t\t\twidth: 70%;\n\t\t}\n\t\tmargin: unset;\n\t}\n\n\t&__column {\n\t\twidth: 100%;\n\t\tdisplay: inline-block;\n\t\tvertical-align: top;\n\t\tmargin-bottom: 2vh;\n\n\t\t&.full-width {\n\t\t\twidth: 100%;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: 40%;\n\t\t\t}\n\t\t}\n\n\t\t@include for-size(\"phone-up\"){\n\t\t\tmargin: 40px 0;\n\t\t}\n\n\t\t@include for-size(\"phone-up\"){\n\t\t\twidth: calc(55% / 2);\n\t\t}\n\n\t\tp {\n\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\tfont-size: 15px;\n\t\t\t\tline-height: 18px;\n\t\t\t}\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tfont-size: 1.4vw;\n\t\t\t\tline-height: 1.8vw;\n\t\t\t}\n\t\t\twidth: 100%;\n\t\t}\n\n\t\ta {\n\t\t\tcolor: #FFF;\n\t\t\ttext-decoration: none;\n\t\t\tpadding: 0;\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\n\t\t.column__title {\n\t\t\tfont-size: 15px;\n\t\t\tfont-weight: 700;\n\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t\tfont-size: 1.4vw;\n\t\t\t\tline-height: 1.8vw;\n\t\t\t}\n\t\t}\n\t}\n}",".page.news {\n\tpadding: 0 20px 20px 20px;\n\n\t.hero {\n\t\theight: 100vh !important;\n\t\twidth: 100vw !important;\n\t\tmargin: 0 0 40px -20px !important;\n\t}\n\t.expanded {\n\t\tdisplay: none;\n\t}\n\t.content__item {\n\t\twidth: 100%;\n\t\theight: 70vw;\n\t\tpadding: 0 20px 20px 20px;\n\t\tmin-height: unset;\n\t\tmargin-bottom: 20px;\n\t\t&.size-2 {\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 40vw;\n\t\t\t}\n\t\t}\n\t\t&.size-1 {\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: 50%;\n\t\t\t\theight: 50vw;\n\t\t\t\tdisplay: inline-block;\n\t\t\t}\n\t\t}\n\t\t.copy {\n\t\t\tfont-family: \"PPNeueMachina\";\n\t\t\tdisplay: block;\n\t\t\tpadding: 0;\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\tpadding: 0 40px 20px 40px;\n\t\t\t}\n\t\t\tp {\n\t\t\t\twidth: unset;\n\t\t\t\tmargin-top: 0;\n\t\t\t\t&:nth-child(1), &:nth-child(2) {\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\twidth: 50%;\n\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\twidth: 25%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:nth-child(2) {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\twidth: 25%;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:nth-child(3){\n\t\t\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\t\t\ttext-align: left;\n\t\t\t\t\t\twidth: 50%;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tb {\n\t\t\t\tcolor: #000;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tbackground: none;\n\t\t\t}\n\n\t\t\ti {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tcolor:#000;\n\t\t\t\topacity: .6;\n\t\t\t\tfont-style: unset;\n\t\t\t}\n\t\t}\n\n\t\t.section__background {\n\t\t\tposition: relative;\n\t\t\tmin-height: unset;\n\t\t\theight: 40vw;\n\t\t}\n\t}\n\t.news__item {\n\t\tposition: relative;\n\t\ta {\n\t\t\tposition: absolute;\n\t\t\twidth: calc(100% - 40px);\n\t\t\theight: calc(100% - 40px);\n\t\t\tz-index: 3;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: unset;\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\t.news__item__content__title {\n\t\t\t\tbackground-color: $green;\n\t\t\t\tcolor: #000;\n\t\t\t}\n\t\t}\n\t\t&__content {\n\t\t\tposition: absolute;\n\t\t\tbottom: 40px;\n    \tleft: 50px;\n    \t@include for-size(\"phone-up\"){\n    \t\tbottom: 80px;\n\t\t\t\tleft: 80px;\n    \t}\n\t\t\t&__info {\n\t\t\t\tcolor:#FFF;\n\t\t\t\t.source {\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tmargin-right: 30px;\n\t\t\t\t\tmargin-right: 60px;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t}\n\t\t\t\t.date {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&__title {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tmargin: 10px 0 0 -10px;\n\t\t\t\tpadding: 5px 10px;\n\t\t\t\tbackground-color: unset;\n\t\t\t\ttext-decoration: underline;\n\t\t\t\ttext-decoration-color: $green;\n\t\t\t\ttext-underline-position: under;\n\t\t\t\tcolor: #FFF;\n\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\tbackground-color: $green;\n\t\t\t\t\tcolor: #000;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&__background {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground-size: cover;\n\t\t\tbackground-position: center;\n\t\t}\n\t}\n}",".page.culture, .page.our-energy {\n\t.page__section {\n\t\t&.expanded {\n\t\t\tpadding: 10px;\n\t\t\tbackground-color: $grey;\n\t\t\tpadding: 20px;\n\t\t\t.culture__grid {\n\t\t\t\tdisplay: -webkit-box; /* Not needed if autoprefixing */\n\t\t\t  display: -ms-flexbox; /* Not needed if autoprefixing */\n\t\t\t  display: flex;\n\t\t\t  margin-left: -20px; /* gutter size offset */\n\t\t\t  width: auto;\n\t\t\t\t.grid__item {\n\t\t\t\t\tpadding-left: 20px; /* gutter size */\n\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\twidth: 100% !important;\n\t\t\t\t\t}\n\t\t\t\t\t@include for-size(\"desktop-up\"){\n\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.culture__item {\n\t\t\t\t\t&:before {\n\t\t\t\t    position: fixed;\n\t\t\t\t    width: 100%;\n\t\t\t\t    height: 100%;\n\t\t\t\t    top:0;\n\t\t\t\t    left:0;\n\t\t\t\t    background: $grey;\n\t\t\t\t    pointer-events: none;\n\t\t\t\t    content:\"\";\n\t\t\t\t    z-index: 2;\n\t\t\t\t    opacity: 0;\n\t\t\t\t    transition: .3s opacity ease-out;\n\t\t\t\t  }\n\t\t\t\t  &.active {\n\t\t\t\t    &:before {\n\t\t\t\t      opacity: 1;\n\t\t\t\t    }\n\t\t\t\t  }\n\t\t\t\t}\n\t\t\t}\n\t\t  margin-right: 40px;\n\t\t  background-color: #F8F8F3;\n\t\t  img {\n\t\t    display: inherit;\n\t\t    width: 100%;\n\t\t  }\n\t\t\t.embed {\n\t\t\t\tpadding: 10px;\n\t\t\t\ta {\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: unset;\n\t\t\t\t\t\tbackground-color: unset;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.section__background {\n\t\t\t\t\tposition: relative;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.culture__item {\n\t\tposition: relative;\n\t\t@include button;\n\t\tmargin-bottom: 20px;\n\t\t&__description {\n\t\t\t&:hover {\n\t\t\t\tbackground: rgba(0,0,0,0.2);\n\t\t\t}\n\t\t\tposition: absolute;\n\t\t\tpadding: 10px;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\ttransition: .2s all ease-out;\n\t\t\th2, p {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tline-height: 26px;\n\t\t\t\tmargin: 0;\n\t\t\t\tcolor: #FFF;\n\t\t\t\tu {\n\t\t\t\t\tcolor: #FFF;\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tbackground-color: #FFF;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.people {\n\t\t&__list {\n\t\t\t&__item {\n\t\t\t\t&__description {\n\t\t\t\t\tleft:15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".partners {\n\theight: 100vh;\n\n\t&__content {\n\t\tpadding: 0 7.5%;\n\t\tpadding-top: 5vh;\n\n\t\tp {\n\t\t\twidth: 100%;\n\t\t\tmargin: unset;\n\t\t\t@include for-size(\"desktop-up\"){\n\t\t\t\twidth: 60%;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__logos {\n\t\t@include for-size(\"desktop-up\"){\n\t\t\tmargin-top: 5vh;\n\t\t}\n\t\timg {\n\t\t\twidth: calc(100% / 4);\n\t\t\tdisplay: inline-block;\n\t\t\ttransform-origin: top left;\n\t\t\tmargin-bottom: -5vw;\n\t\t\tmax-width: 150px;\n\n\t\t\t@include for-size(\"desktop-up\"){\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tmax-width: 220px;\n\t\t\t\tmax-height: 10.5vw;\n\t\t\t\twidth: auto;\n\t\t\t}\n\n\t\t\t@include for-size(\"big-desktop-up\") {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\twidth: auto;\n\t\t\t}\n\t\t}\n\t}\n}",".people {\n\t&__list {\n\t\tpadding: 0 7.5%;\n\t\tfont-size: 0;\n\t\tpadding: 80px 40px;\n\n\t\t&__item {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\tdisplay: inline-block;\n\t\t\tvertical-align: top;\n\t\t\t@include button;\n\n\t\t\ta {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tbackground: none;\n\t\t\t\ttext-decoration: none;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\t.people__list__item__description {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__description {\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 3;\n\t\t\t\tbackground: rgba(0, 0, 0, 0.5);\n\t\t\t\tcolor: #FFF;\n\t\t\t\twidth: calc(100% - 40px);\n\t\t\t\theight: calc(100% - 40px);\n\t\t\t\topacity: 0;\n\t\t\t\ttransition: .5s opacity ease-out;\n\t\t\t\tpointer-events: none;\n\t\t\t\ttop: 20px;\n\t\t\t\tleft: 20px;\n\n\t\t\t\t.description__copy {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 30px;\n\t\t\t\t\tbottom: 40px;\n\t\t\t\t}\n\n\t\t\t\tp {\n\t\t\t\t\tline-height: 24px;\n\t\t\t\t\tmargin-top: 0;\n\n\t\t\t\t\t@include for-size(\"phone-only\"){\n\t\t\t\t\t\tline-height: 18px;\n\t\t\t\t\t}\n\n\t\t\t\t\t&.role {\n\t\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\timg {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tpadding: 20px;\n\t\t\t}\n\n\t\t\t@include for-size(\"phone-up\"){\n\t\t\t\twidth: calc(100% / 3);\n\t\t\t}\n\t\t}\n\t}\n}",".anti-racism {\n\t.expand-cta {\n\t\tposition: absolute;\n\t\tz-index: 3;\n\t\t@include horzCenter;\n\t\tbottom: 10vh;\n\t\tfont-size: 20px;\n\t\tbackground: $green;\n\t\tdisplay: inline-block;\n\t\tpadding: 5px;\n\t\tcolor:#000;\n\t\t@include button;\n\n\t\t&:hover {\n\t\t\tbackground: #000;\n\t\t\tcolor: #FFF;\n\t\t}\n\t}\n\t.hero {\n\t\ttransition: .5s ease-out all;\n\n\t\t&__content {\n\t\t\tposition: relative;\n\t\t\tpadding-top: 20vh;\n\t\t\tmargin-bottom: 60px;\n\t\t\ttop: unset;\n\t\t\tleft: unset;\n\t\t\ttransform: unset;\n\t\t}\n\t}\n\t&.expanded {\n\t\t.hero {\n\t\t\tmin-height: 50vh;\n\t\t}\n\t\t.expand-cta {\n\t\t\tbottom: 30px;\n\t\t}\n\t}\n\t.page__section__top {\n\t\tposition: absolute;\n\t\t@include centerCenter;\n\t\twidth: 100%;\n\t}\n\t.expanded-content {\n\t\tposition: relative;\n\t\theight: 0;\n\t\tpadding: 0 7.5%;\n\t\toverflow: hidden;\n\t\ttransition: .3s ease-out height;\n\n\t\t&.expanded {\n\t\t\tpadding: 0 7.5% 120px 7.5%;\n\t\t\theight: auto;\n\n\t\t\t.expanded {\n\t\t\t\tbottom: 0px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.partners {\n\tpadding-bottom: 0 !important;\n\t.headline {\n\t\tposition: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n    background-color: $green;\n    color: #000;\n    line-height: 50px;\n    white-space: nowrap;\n    text-transform: uppercase;\n    animation: 8s marquee linear infinite;\n   \tcursor: default;\n   \toverflow-x: hidden;\n    @include for-size(\"phone-up\") {\n\t\t\tanimation: 3s marqueeDesktop linear infinite;\n\t\t\tline-height: 80px;\n    }\n    display: inline-block;\n\n    b {\n    \tdisplay: unset;\n    }\n\n    &:before {\n    \tcontent:\"Our proud partners ↓\";\n    \tpadding-right: 12px;\n    \t@include for-size(\"phone-up\") {\n    \t\tpadding-right: 20px;\n    \t}\n    }\n\n    &:after {\n    \tcontent:\"Our proud partners ↓\";\n    \tpadding-left: 12px;\n    \t@include for-size(\"phone-up\") {\n    \t\tpadding-right: 20px;\n    \t}\n    }\n\n    &:empty {\n    \tdisplay: none;\n    }\n\t}\n\t.embedded__media {\n\t\twidth: calc(100% / 4);\n\t\tdisplay: inline-block;\n\t\tpadding: 20px 0;\n\n\t\t@include for-size(\"desktop-up\"){\n\t\t\twidth: calc(100% / 7);\n\t\t}\n\t}\n}\n\n.map {\n\tposition: relative;\n\tpadding: 0 !important;\n\t.headline {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\tpadding: 60px 7.5%;\n\t\tcolor: #FFF;\n\t\t@include gradient(270deg);\n\t}\n}\n\n.lazyload-wrapper {\n\theight: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
